// Authored Sales UI copy. Numeric placeholders preserve customer data at render time.
export const employeeArabicTranslations: Record<string, string> = {
  "Paid amount is a separate deposit": "المبلغ المدفوع مقدم منفصل عن الأقساط",
  "Enter a payment count, not the course price. Enable the separate deposit option when the first payment is outside the installment plan.": "اكتب عدد الدفعات، مش سعر الكورس. فعّل اختيار المقدم المنفصل لو أول دفعة خارج أقساط المحاضرات.",
  "Reception sets the due dates after confirming the class schedule.": "الريسبشن بيحدد مواعيد الاستحقاق بعد تأكيد جدول المحاضرات.",
  "Enter the number of future payments and the amount of each payment. The deposit is added separately.": "اكتب عدد الدفعات المتبقية وقيمة كل دفعة. المقدم بيتضاف لوحده عند تفعيل الاختيار.",
  "Enter the number of installments (2–120), not the course price.": "اكتب عدد الأقساط من ٢ إلى ١٢٠، مش سعر الكورس.",
  "Total Price = deposit + remaining installments + previous payments.": "الإجمالي = المقدم + الأقساط المتبقية + الدفعات السابقة.",
  "Unable to upload attachment": "مش قادرين نرفع المرفق",
  "Attach files": "إرفاق ملفات",
  "No attachments yet": "لسه مفيش مرفقات",
  "Email template": "قالب الإيميل",
  "Select a template": "اختار قالب",
  "Correct stage / outcome": "تصحيح المرحلة / النتيجة",
  "Set a follow-up": "تحديد متابعة",
  "Add note": "إضافة ملاحظة",
  "Registration link": "رابط التسجيل",
  "Request transfer": "طلب تحويل",
  "Need review": "محتاج مراجعة",
  "Request marketing PDF": "طلب ملف PDF من التسويق",
  "Lead actions": "إجراءات العميل",
  "Phone not provided": "رقم التليفون مش موجود",
  "New Lead": "عميل محتمل جديد",
  "Existing student": "طالب موجود",
  "WhatsApp pending": "واتساب في الانتظار",
  "Call": "اتصال",
  "More": "المزيد",
  "Course / Service for marketing PDF": "الكورس / الخدمة لملف التسويق",
  "Check PDF": "مراجعة ملف PDF",
  "Request from marketing": "طلب من التسويق",
  "Open current PDF": "فتح ملف PDF الحالي",
  "No marketing PDF found": "مفيش ملف PDF للتسويق",
  "Unable to submit review request": "مش قادرين نبعت طلب المراجعة",
  "Need Review": "محتاج مراجعة",
  "Submit Review": "إرسال المراجعة",
  "Review reason": "سبب المراجعة",
  "Later today": "في وقت تاني النهارده",
  "Tomorrow": "بكرة",
  "In 2 days": "بعد يومين",
  "Next week": "الأسبوع الجاي",
  "Outcome saved": "النتيجة اتحفظت",
  "Unable to save outcome": "مش قادرين نحفظ النتيجة",
  "What happened with": "إيه اللي حصل مع",
  "this lead": "العميل ده",
  "Current stage:": "المرحلة الحالية:",
  "Lead outcomes": "نتائج التواصل مع العميل",
  "Show common outcomes": "عرض النتائج الشائعة",
  "More outcomes": "نتائج تانية",
  "(optional)": "(اختياري)",
  "What should the next person know?": "إيه اللي محتاج الشخص اللي بعدك يعرفه؟",
  "Choose a reason": "اختار سبب",
  "First contact": "أول تواصل",
  "Course details": "تفاصيل الكورس",
  "Follow-up after no answer": "متابعة بعد عدم الرد",
  "Template": "القالب",
  "What happened with this lead?": "إيه اللي حصل مع العميل ده؟",
  "Contact result": "نتيجة التواصل",
  "Next follow-up": "المتابعة الجاية",
  "Current:": "الحالي:",
  "(overdue)": "(متأخر)",
  "New follow-up date and time": "ميعاد المتابعة الجديد",
  "Add result details...": "ضيف تفاصيل النتيجة...",
  "Suggested stage:": "المرحلة المقترحة:",
  "unchanged": "زي ما هي",
  "Type an email and press Enter": "اكتب إيميل واضغط Enter",
  "Unable to submit transfer request": "مش قادرين نبعت طلب التحويل",
  "Request Transfer": "طلب تحويل",
  "Transfer reason": "سبب التحويل",
  "Preferred employee (optional)": "الموظف المفضل (اختياري)",
  "Preferred employee": "الموظف المفضل",
  "Team Leader/Admin chooses final assignee": "قائد الفريق أو الأدمن بيختار المسؤول النهائي",
  "Request creates a pending transfer only. Assignee and stage do not change until Team Leader/Admin approval.": "الطلب بيعمل تحويل في الانتظار بس. المسؤول والمرحلة مش بيتغيروا إلا بعد موافقة قائد الفريق أو الأدمن.",
  "All template variables resolved.": "كل متغيرات القالب اتحددت.",
  "Template has unresolved variables": "القالب فيه متغيرات لسه مش محددة",
  "Missing: {0}": "ناقص: {0}",
  "This email has unsaved changes. Discard them and leave?": "الإيميل فيه تعديلات مش محفوظة. تتجاهلها وتخرج؟",
  "Enter course name first": "اكتب اسم الكورس الأول",
  "Marketing PDF request submitted": "طلب ملف التسويق اتبعت",
  "Unable to request marketing PDF": "مش قادرين نطلب ملف التسويق",
  "Recipient email is required": "إيميل المستلم مطلوب",
  "Email body is required": "محتوى الإيميل مطلوب",
  "Unable to send email": "مش قادرين نبعت الإيميل",
  "Draft saved": "المسودة اتحفظت",
  "Unable to save draft": "مش قادرين نحفظ المسودة",
  "WorkMail Compose": "كتابة رسالة WorkMail",
  "Save Draft": "حفظ المسودة",
  "Customer email not provided.": "إيميل العميل مش موجود.",
  "Email action needs a valid customer email.": "إرسال الإيميل محتاج عنوان إيميل صحيح للعميل.",
  "Primary recipient": "المستلم الأساسي",
  "CC": "نسخة",
  "Attachments": "المرفقات",
  "Email preview": "معاينة الإيميل",
  "Discard draft?": "تتجاهل المسودة؟",
  "Discard": "تجاهل",
  "Keep Editing": "كمّل التعديل",
  "You have unsaved changes in this email. Discard them and close the message?": "في تعديلات مش محفوظة في الإيميل. تتجاهلها وتقفل الرسالة؟",
  "Unpin": "إلغاء التثبيت",
  "Pin": "تثبيت",
  "Lead:": "العميل:",
  "Outcome:": "النتيجة:",
  "Email #": "إيميل #",
  "Transfer #": "تحويل #",
  "Next action:": "الخطوة الجاية:",
  "Search lead, phone, note, outcome": "دور بالعميل أو الرقم أو الملاحظة أو النتيجة",
  "Filter Lead name or phone": "فلتر باسم العميل أو رقمه",
  "Hide Advanced": "إخفاء الخيارات المتقدمة",
  "Advanced": "خيارات متقدمة",
  "Event Type": "نوع النشاط",
  "Has Notes": "فيه ملاحظات",
  "Important only": "المهم بس",
  "Task related": "مرتبط بمهمة",
  "Contact related": "مرتبط بالتواصل",
  "Calls": "المكالمات",
  "Logged calls": "المكالمات المسجلة",
  "Chat touches": "تواصل بالمحادثة",
  "Context captured": "تفاصيل اتسجلت",
  "Next actions set": "خطوات جاية اتحددت",
  "Tasks Done": "المهام المكتملة",
  "Queue cleared": "الطابور خلص",
  "Opened Leads": "العملاء اللي اتفتحوا",
  "Lead views": "مرات عرض العملاء",
  "event": "نشاط",
  "Add Activity": "إضافة نشاط",
  "Save Activity": "حفظ النشاط",
  "Meeting": "مقابلة",
  "Objection": "اعتراض",
  "Outcome (optional based on type)": "النتيجة (اختيارية حسب النوع)",
  "Related next action": "الخطوة الجاية المرتبطة",
  "Mark as important": "تحديد كمهم",
  "Public/Internal Note": "ملاحظة عامة / داخلية",
  "Private Note": "ملاحظة خاصة",
  "Public Note": "ملاحظة عامة",
  "Visibility defaults to internal behavior when backend controls are unavailable.": "الملاحظات بتكون داخلية تلقائيًا لو إعدادات الظهور مش متاحة في الخادم.",
  "Important": "مهم",
  "Start by calling, sending WhatsApp, or adding a note.": "ابدأ بمكالمة أو رسالة واتساب أو إضافة ملاحظة.",
  "Clear the selected metric or reset filters to bring the full timeline back.": "امسح المؤشر المختار أو صفّر الفلاتر عشان ترجع كل الأنشطة.",
  "No activity logged today yet": "لسه مفيش نشاط متسجل النهارده",
  "Open this week to review recent work, or jump straight to the active task queue.": "افتح الأسبوع ده عشان تراجع شغلك الأخير، أو روح على طول لطابور المهام الحالي.",
  "No activity recorded for this period": "مفيش نشاط متسجل في الفترة دي",
  "Try another range or go back to the live sales queues.": "جرّب فترة تانية أو ارجع لطوابير السيلز الحالية.",
  "Activity period": "فترة النشاط",
  "Activity views": "طرق عرض النشاط",
  "Hide filters": "إخفاء الفلاتر",
  "Edit Activity Note": "تعديل ملاحظة النشاط",
  "Save Note": "حفظ الملاحظة",
  "Write the useful context for this activity": "اكتب التفاصيل المفيدة للنشاط ده",
  "Added": "اتضاف",
  "Use any page": "استخدم أي صفحة",
  "What each item means": "معنى كل عنصر قدامك",
  "Every Sales page works the same way: search and filters control what you see, cards and tables show the results, and buttons take action on a customer or task.": "أي صفحة في السيلز فيها نفس القاعدة: البحث والفلاتر بيحددوا اللي شايفه، الكروت والجداول بتعرض النتيجة، والأزرار بتنفذ خطوة على العميل أو الشغل.",
  "When a label or button leaves you unsure where to start.": "لو واقف قدام أي كلمة أو زر ومش عارف تبدأ منين.",
  "Use the visible controls confidently without losing your work.": "تتعامل مع العناصر الظاهرة بهدوء ومن غير ما تضيّع شغلك.",
  "Confirm and Save buttons apply your choices. Check the name, number, and time before clicking.": "أي زر تأكيد أو حفظ بيطبق اختيارك؛ راجع الاسم والرقم والموعد قبل ما تضغطه.",
  "Start here": "ابدأ من هنا",
  "Where should I start?": "أبدأ شغلك منين؟",
  "A quick guide to your first task of the day.": "خريطة سريعة تخليك تعرف أول حاجة تعملها في يومك.",
  "At the start of your shift or when leads and tasks feel overwhelming.": "في أول الشيفت أو لما تحس إن العملاء والمهام كتير.",
  "Keep your work organized and never miss a follow-up.": "شغلك يبقى مرتب ومفيش متابعة تضيع.",
  "Customer work": "شغل العميل",
  "Pipeline": "مراحل البيع",
  "All your potential customers and their progress through the sales journey.": "هنا كل العملاء المحتملين ومكان كل واحد في رحلة البيع.",
  "When finding a lead, starting a follow-up, or setting priorities.": "لما تدور على عميل، تبدأ متابعة، أو ترتب أولوياتك.",
  "The card updates, keeping history and tasks clear for the team.": "الكارت بيتحدث، والسجل والمهام بيفضلوا واضحين للفريق.",
  "Do not change a stage just to try it out; it affects team reports.": "ما تغيّرش المرحلة لمجرد التجربة؛ المرحلة بتأثر على تقارير الفريق.",
  "Customer details and actions": "تفاصيل العميل والإجراءات",
  "The drawer with customer details, activity, follow-ups, and transfers.": "الدرج اللي فيه بيانات العميل، النشاط، والمتابعة والتحويل.",
  "After opening any customer card.": "بعد ما تفتح أي كارت عميل.",
  "Every action is documented in the customer history.": "كل خطوة تبقى موثقة في سجل العميل.",
  "A transfer request does not change ownership automatically; a manager reviews it.": "طلب التحويل مش بينقل الملكية تلقائيًا؛ المدير بيراجعه.",
  "Employee work": "شغل الموظف",
  "Follow-ups you need to complete, ordered by priority and due time.": "قائمة المتابعات اللي لازم تتعمل، مرتبة بالأولوية والميعاد.",
  "To finish today's due tasks or plan your day.": "عشان تخلص المستحق النهارده أو ترتب يومك.",
  "The task closes or moves to a new time, updating your work priorities.": "المهمة بتتقفل أو بتنتقل للميعاد الجديد، وأولوية الشغل بتتحدث.",
  "Do not mark a task complete just to clear the list; it disrupts customer follow-up.": "ما تقفلش المهمة لمجرد تنظيف القائمة؛ ده يبوّظ متابعة العميل.",
  "WhatsApp conversations linked to Sales accounts.": "مكان محادثات واتساب المربوطة بحسابات السيلز.",
  "When a customer writes to you or you need to follow up with a message.": "لما العميل يتواصل كتابة أو تحتاج تكمل متابعة برسالة.",
  "The conversation stays connected to the customer context and team work.": "المحادثة بتفضل مرتبطة بتفاصيل العميل وشغل الفريق.",
  "Check the customer name and message before sending; sending is not automatically reversible.": "راجع اسم العميل والرسالة قبل الإرسال؛ الإرسال مش بيتراجع تلقائيًا.",
  "Your activity history for reviewing calls, messages, and follow-ups.": "تاريخ نشاطك عشان تراجع المكالمات والرسائل والمتابعات.",
  "When checking what was done or reviewing your work over a period.": "لما تحتاج تعرف إيه اللي اتعمل أو تراجع شغلك في فترة.",
  "Track your work and understand the customer journey without guessing.": "تقدر تتابع شغلك وتفهم رحلة العميل من غير تخمين.",
  "Performance": "الأداء",
  "Your activity and conversion figures show where you need to focus.": "أرقام نشاطك وتحويلاتك عشان تعرف محتاج تركز فين.",
  "At the end of the day or when reviewing a period's performance.": "في آخر اليوم أو لما تراجع أداء فترة.",
  "Make decisions based on your actual work.": "تقدر تاخد قرار مبني على شغلك الفعلي.",
  "Team management": "إدارة الفريق",
  "Manager Dashboard": "لوحة المدير",
  "A complete team view: results, distribution, and priorities.": "صورة الفريق كاملة: النتائج، التوزيع، والأولويات.",
  "During daily monitoring, team meetings, or period reviews.": "في متابعة يومية أو اجتماع فريق أو مراجعة فترة.",
  "Spot team issues early and make clear decisions.": "تشوف مشاكل الفريق بدري وتاخد قرار واضح.",
  "Course distribution": "توزيع الكورسات",
  "Assign course responsibilities within the team.": "تحديد مين مسؤول عن الكورسات ضمن الفريق.",
  "When changing team coverage or adding an employee.": "لما تغيّر تغطية فريق أو تضيف موظف.",
  "The updated distribution is ready for the team to use.": "التوزيع الجديد يبقى جاهز لشغل الفريق.",
  "Changes affect future assignments; review them before saving.": "التغيير بيأثر على الاستلام الجاي؛ راجع قبل الحفظ.",
  "Customer transfers": "نقل العملاء",
  "Transfer or redistribute leads between team members in an organized way.": "نقل أو إعادة توزيع العملاء المحتملين بين أعضاء الفريق بشكل منظم.",
  "When an employee is absent, workloads increase, or a customer needs another owner.": "لما موظف يغيب، الحمل يزيد، أو العميل محتاج مسؤول تاني.",
  "Ownership changes and the transfer is recorded for review.": "الملكية بتتغير وأثر النقل بيتسجل للمراجعة.",
  "Transferring a customer affects responsibility and reports; always have a clear reason.": "نقل العميل بيأثر على المسؤولية والتقارير؛ ما تنقلش من غير سبب واضح.",
  "Tele-sales management": "إدارة المبيعات التليفونية",
  "Monitor the qualification queue and handoff or rejection decisions.": "متابعة طابور التأهيل وقرارات التسليم أو الرفض.",
  "When reviewing Tele-sales quality or managing distribution.": "لما تراجع جودة شغل المبيعات التليفونية أو تدير التوزيع.",
  "Qualified leads reach the right workflow with their context intact.": "عملاء مؤهلين بيوصلوا للمسار الصح بكل تفاصيلهم.",
  "Data management": "إدارة البيانات",
  "Review how ad sources and incoming Sales data are linked.": "مراجعة ربط مصادر الإعلانات والبيانات الداخلة للسيلز.",
  "When a new source or campaign is not appearing correctly.": "لما مصدر أو حملة جديدة مش ظاهرة بالشكل الصح.",
  "Cleaner data enters the pipeline.": "البيانات بتدخل بشكل أنضف في مراحل البيع.",
  "Link changes may affect new data; review the preview first.": "تعديل الربط ممكن يأثر على البيانات الجديدة؛ راجع المعاينة الأول.",
  "Targets, reports, and settings": "الأهداف والتقارير والإعدادات",
  "Set targets, read results, and configure work templates.": "تحديد الهدف، قراءة النتائج، وضبط قوالب الشغل.",
  "At the start of a new period, when reviewing results, or when changing an operational setting.": "في بداية فترة جديدة أو مراجعة نتائج أو تغيير إعداد تشغيلي.",
  "Keep targets, reports, and settings aligned with how the team operates.": "الأهداف والتقارير والإعدادات تفضل متوافقة مع طريقة التشغيل.",
  "Templates and settings affect the entire team; review them before saving.": "القوالب والإعدادات بتأثر على الفريق كله؛ راجعها قبل الحفظ.",
  "Tele-sales work": "شغل المبيعات التليفونية",
  "Tele-sales queue": "طابور المبيعات التليفونية",
  "Leads that need qualification before handoff to Sales.": "عملاء محتاجين تأهيل قبل ما يتسلموا للسيلز.",
  "Throughout the Tele-sales shift.": "طول شيفت المبيعات التليفونية.",
  "Qualify and hand off the lead, or record a clear reason for its status.": "العميل يا إما يتأهل ويتسلم، يا إما يتسجل سبب واضح للحالة.",
  "Write an accurate rejection reason so the manager can review the decision.": "اكتب سبب الرفض بدقة عشان المدير يعرف يراجع القرار.",
  "Sales help guide": "دليل مساعدة السيلز",
  "Your step-by-step work guide": "دليل شغلك خطوة بخطوة",
  "Choose a topic or search for the action you want to understand.": "اختار موضوع أو دور على الإجراء اللي عايز تعرفه.",
  "Search help": "دور في المساعدة",
  "Example: customer transfer, follow-up, or WhatsApp": "مثال: نقل عميل أو متابعة أو واتساب",
  "Help topics": "موضوعات المساعدة",
  "No matching topic. Try a simpler word or clear your search.": "ملقيناش موضوع بالبحث ده. جرّب كلمة أبسط أو امسح البحث.",
  "When should I use it?": "استخدمها إمتى؟",
  "Before you start": "قبل ما تبدأ",
  "What should I do?": "اعمل إيه؟",
  "Result:": "النتيجة:",
  "Keep in mind:": "خلي بالك:",
  "This lead has no callable phone number": "العميل ده ملوش رقم ينفع تتصل بيه",
  "Messaging is disabled": "المراسلة متوقفة",
  "This lead has no WhatsApp phone number": "العميل ده ملوش رقم واتساب",
  "{0}d overdue": "متأخر {0} يوم",
  "Overdue today": "متأخر النهارده",
  "Lead ownership and timing": "مسؤولية العميل ومواعيده",
  "Owner:": "المسؤول:",
  "Next follow-up:": "المتابعة الجاية:",
  "Next step: Open details to review": "الخطوة الجاية: افتح التفاصيل للمراجعة",
  "Last contact:": "آخر تواصل:",
  "Phone:": "التليفون:",
  "Not set": "مش محدد",
  "Stage:": "المرحلة:",
  "Lead contact actions": "إجراءات التواصل مع العميل",
  "Open lead details": "فتح تفاصيل العميل",
  "Check invoice path": "مراجعة مسار الفاتورة",
  "Review record": "مراجعة السجل",
  "Audit reason": "سبب المراجعة",
  "Stay on plan": "كمّل حسب الخطة",
  "Review next step": "مراجعة الخطوة الجاية",
  "Last touch": "آخر تواصل",
  "{0} stage": "مرحلة {0}",
  "{0} visible leads": "{0} عميل ظاهر",
  "{0} leads in this view{1}": "{0} عميل في العرض ده{1}",
  "· Stage capacity {0}": "· سعة المرحلة {0}",
  "No leads match the current filters.": "مفيش عملاء مطابقين للفلاتر الحالية.",
  "No leads in this stage": "مفيش عملاء في المرحلة دي",
  "Clear a filter or choose another stage.": "امسح فلتر أو اختار مرحلة تانية.",
  "This stage has more leads. Load them to review the queue.": "المرحلة دي فيها عملاء كمان. حمّلهم عشان تراجع الطابور.",
  "Drag a lead here or add a new lead.": "اسحب عميل هنا أو ضيف عميل جديد.",
  "Drag a lead here or choose another stage.": "اسحب عميل هنا أو اختار مرحلة تانية.",
  "{0} pagination": "صفحات {0}",
  "of": "من",
  "Previous {0} page": "صفحة {0} السابقة",
  "Next {0} page": "صفحة {0} الجاية",
  "Load more {0} leads": "تحميل عملاء {0} أكتر",
  "Loading…": "جاري التحميل…",
  "Load more": "تحميل المزيد",
  "Checking phone number…": "جاري مراجعة رقم التليفون…",
  "Live Lecture": "محاضرة مباشرة",
  "Recorded Lecture": "محاضرة مسجلة",
  "Demo Type *": "نوع الديمو *",
  "Select Demo Type": "اختار نوع الديمو",
  "Demo Status": "حالة الديمو",
  "Sent – Awaiting View": "اتبعت – في انتظار المشاهدة",
  "Demo Date *": "تاريخ الديمو *",
  "Demo Time *": "وقت الديمو *",
  "Course / Group": "الكورس / المجموعة",
  "Select Course / Group": "اختار الكورس / المجموعة",
  "Recorded Lecture / Link *": "المحاضرة المسجلة / الرابط *",
  "Select Recorded Lecture": "اختار محاضرة مسجلة",
  "Or paste a link": "أو حط رابط",
  "https://": "https://",
  "Sent Date": "تاريخ الإرسال",
  "Automatic on save": "تلقائي عند الحفظ",
  "{0}Next Follow-Up *": "{0}المتابعة الجاية *",
  "{0}Demo Next Action Date *": "{0}تاريخ الخطوة الجاية للديمو *",
  "{0}Next Follow-Up Time *": "{0}وقت المتابعة الجاية *",
  "{0}Demo Next Action Time *": "{0}وقت الخطوة الجاية للديمو *",
  "Demo Type": "نوع الديمو",
  "Demo Date / Time": "ميعاد الديمو",
  "Next Action": "الخطوة الجاية",
  "Selected Result": "النتيجة المختارة",
  "5. Demo Details": "٥. تفاصيل الديمو",
  "Inline with this attempt": "ضمن المحاولة دي",
  "Demo Result will be available after": "نتيجة الديمو هتكون متاحة بعد",
  "Demo Result *": "نتيجة الديمو *",
  "Demo Result": "نتيجة الديمو",
  "Next Follow-Up Date *": "تاريخ المتابعة الجاية *",
  "Next Follow-Up Date": "تاريخ المتابعة الجاية",
  "Next Follow-Up Time *": "وقت المتابعة الجاية *",
  "Next Follow-Up Time": "وقت المتابعة الجاية",
  "Next Step *": "الخطوة الجاية *",
  "Demo Next Step": "الخطوة الجاية للديمو",
  "Next Action Date *": "تاريخ الخطوة الجاية *",
  "Demo Follow-Up Date": "تاريخ متابعة الديمو",
  "Next Action Time *": "وقت الخطوة الجاية *",
  "Demo Follow-Up Time": "وقت متابعة الديمو",
  "Replacement Demo": "ديمو بديل",
  "Saving starts the Registration Link handoff. The stage remains Demo until the customer completes registration.": "الحفظ بيبدأ خطوة رابط التسجيل. المرحلة بتفضل ديمو لحد ما العميل يكمّل التسجيل.",
  "Notes are required for Note / Objection": "الملاحظات مطلوبة للملاحظة / الاعتراض",
  "Activity added": "النشاط اتضاف",
  "Unable to add activity": "مش قادرين نضيف النشاط",
  "Activity note updated": "ملاحظة النشاط اتحدثت",
  "Unable to edit note": "مش قادرين نعدل الملاحظة",
  "Lead activity evidence": "سجل نشاط العميل",
  "Choose reception-managed slots. Selection can move the lead to": "اختار من المواعيد اللي بيديرها الاستقبال. الاختيار ممكن ينقل العميل إلى",
  "Meeting/Consultation Scheduled": "مقابلة / استشارة محجوزة",
  "when applicable.": "لو ده ينطبق.",
  "Need a private meeting?": "محتاج مقابلة خاصة؟",
  "Creates one reception appointment for this lead.": "بيعمل موعد واحد في الاستقبال للعميل ده.",
  "No mapped course": "مفيش كورس مربوط",
  "Place (room / online)": "المكان (قاعة / أونلاين)",
  "Add Private": "إضافة موعد خاص",
  "Loading reception slots...": "جاري تحميل مواعيد الاستقبال...",
  "No consultation slots available from reception.": "مفيش مواعيد استشارة متاحة من الاستقبال.",
  "private": "خاص",
  "No date": "من غير تاريخ",
  "Clearing all selections keeps the current stage as-is.": "إلغاء كل الاختيارات بيسيّب المرحلة الحالية زي ما هي.",
  "events": "أنشطة",
  "Activity unpinned": "تثبيت النشاط اتلغى",
  "Activity pinned": "النشاط اتثبت",
  "Unable to update activity": "مش قادرين نحدث النشاط",
  "Load older history": "تحميل سجل أقدم",
  "Stage Trail": "سجل المراحل",
  "Captured Context": "التفاصيل المسجلة",
  "Next Obligation": "المطلوب بعد كده",
  "Unable to load this section.": "مش قادرين نحمّل القسم ده.",
  "Retry": "جرّب تاني",
  "Loading activity": "جاري تحميل النشاط",
  "Previous attempts and activity": "المحاولات والنشاط السابق",
  "Read-only history of contact attempts, comments, and lead changes.": "سجل للقراءة بس لمحاولات التواصل والتعليقات وتغييرات العميل.",
  "Contact attempts": "محاولات التواصل",
  "No contact attempts recorded yet.": "لسه مفيش محاولات تواصل متسجلة.",
  "Open comment for {0} #{1}": "فتح تعليق {0} #{1}",
  "Open comment": "فتح التعليق",
  "No comment": "مفيش تعليق",
  "View all attempts (": "عرض كل المحاولات (",
  "No comments linked to this lead yet.": "لسه مفيش تعليقات مرتبطة بالعميل ده.",
  "Contact": "تواصل",
  "View all comments (": "عرض كل التعليقات (",
  "Activity Timeline": "سجل النشاط",
  "No activity recorded yet.": "لسه مفيش نشاط متسجل.",
  "View all activities (": "عرض كل الأنشطة (",
  "Load older activity": "تحميل نشاط أقدم",
  "Additional Information": "معلومات إضافية",
  "Lead answers from the source sheet": "إجابات العميل من شيت المصدر",
  "fields": "حقول",
  "Not provided": "مش موجود",
  "Assignment Control": "إدارة التعيين",
  "Native reassignment with audit trail": "إعادة تعيين مع تسجيل التغيير",
  "No eligible sales owners available": "مفيش موظفين سيلز متاحين للتعيين",
  "Assign to...": "تعيين إلى...",
  "Select a valid employee": "اختار موظف صالح للتعيين",
  "Lead is already assigned to this employee": "العميل متعيّن للموظف ده بالفعل",
  "Ownership Timeline": "سجل المسؤولية",
  "No ownership actions yet.": "لسه مفيش تغييرات في المسؤولية.",
  "Date not available": "التاريخ مش متاح",
  "InstaPay": "إنستاباي",
  "Mobile Wallet": "محفظة موبايل",
  "Loading conversion details": "جاري تحميل تفاصيل التحويل لطالب",
  "Payment Overview": "ملخص الدفع",
  "Total Receipts": "إجمالي الإيصالات",
  "Paid status requires verification: no matching approved collection was found. Do not create a replacement receipt without checking the payment ledger.": "حالة «مدفوع» محتاجة تحقق: ملقيناش تحصيل معتمد مطابق. ما تعملش إيصال بديل قبل مراجعة سجل الدفع.",
  "Approved collection (EGP)": "التحصيل المعتمد (جنيه)",
  "Awaiting approval (EGP)": "في انتظار الموافقة (جنيه)",
  "Transferred course credit (EGP)": "رصيد كورس منقول (جنيه)",
  "Agreed course total": "إجمالي الكورس المتفق عليه",
  "Remaining Balance": "الرصيد المتبقي",
  "Course price requires confirmation. A zero configured price does not mean fully paid.": "سعر الكورس محتاج تأكيد. لو السعر المسجل صفر، ده مش معناه إن المبلغ مدفوع بالكامل.",
  "Registration:": "التسجيل:",
  "Not completed": "مش مكتمل",
  "Awaiting customer payment ·": "في انتظار دفع العميل ·",
  "Marketing review:": "مراجعة التسويق:",
  "· Reception review:": "· مراجعة الاستقبال:",
  "· Approved collection:": "· التحصيل المعتمد:",
  "Invoices and collection evidence": "الفواتير ومستندات التحصيل",
  "Receipts": "الإيصالات",
  "Registration incomplete": "التسجيل مش مكتمل",
  "Partially paid": "مدفوع جزئيًا",
  "Payment received": "تم استلام الدفع",
  "Awaiting customer payment": "في انتظار دفع العميل",
  "Awaiting Marketing review": "في انتظار مراجعة التسويق",
  "Awaiting Reception review": "في انتظار مراجعة الريسبشن",
  "First Sales Receipt": "أول إيصال سيلز",
  "Balance Due": "المبلغ المستحق",
  "Price required": "السعر مطلوب",
  "At Course Start": "عند بداية الكورس",
  "Fully Paid": "مدفوع بالكامل",
  "Unscheduled balance:": "مبلغ متبقي من غير ميعاد:",
  ". Set a due date in Reception.": "حدد ميعاد استحقاق في الاستقبال.",
  "Installment schedule exceeds the remaining balance. Review the schedule.": "جدول الأقساط أكبر من الرصيد المتبقي. راجع الجدول.",
  "st": "الأول",
  "nd": "الثاني",
  "rd": "الثالث",
  "Installment Due": "القسط المستحق",
  "Installment due dates will appear after the receipt is created.": "مواعيد الأقساط هتظهر بعد إنشاء الإيصال.",
  "Select a payment plan to see its payment summary.": "اختار خطة دفع عشان تشوف ملخصها.",
  "Arabian Academy payment link": "رابط دفع Arabian Academy",
  "Conversion details are unavailable.": "تفاصيل التحويل لطالب مش متاحة.",
  "Share the link. Receipt creation unlocks after the customer completes registration.": "شارك الرابط. إنشاء الإيصال هيتاح بعد ما العميل يكمّل التسجيل.",
  "Create a registration link, then share it with the customer.": "اعمل رابط تسجيل، وبعدها شاركه مع العميل.",
  "Registration link unavailable": "رابط التسجيل مش متاح",
  "Copy Link": "نسخ الرابط",
  "Share Link": "مشاركة الرابط",
  "Creating link…": "جاري إنشاء الرابط…",
  "Create registration link": "إنشاء رابط تسجيل",
  "Registration completed successfully": "التسجيل اكتمل بنجاح",
  "Link opened — waiting for completed registration": "الرابط اتفتح — في انتظار اكتمال التسجيل",
  "Waiting for the customer to open the link": "في انتظار إن العميل يفتح الرابط",
  "Add another receipt": "إضافة إيصال تاني",
  "Receipt review status": "حالة مراجعة الإيصال",
  "Receipt pending review": "الإيصال في انتظار المراجعة",
  "Marketing review": "مراجعة التسويق",
  "Reception / Accounts review": "مراجعة الاستقبال / الحسابات",
  "is awaiting approval. Your submitted receipts cover the remaining amount. Wait for their review before adding another receipt.": "في انتظار الموافقة. الإيصالات اللي قدمتها بتغطي المبلغ المتبقي. استنى مراجعتها قبل إضافة إيصال تاني.",
  "Approved collection is {0}.": "التحصيل المعتمد {0}.",
  "Pending receipts do not count as approved collection; the financial remaining balance changes after approval.": "الإيصالات اللي في الانتظار مش بتتحسب ضمن التحصيل المعتمد؛ الرصيد المالي المتبقي بيتغير بعد الموافقة.",
  "Review status could not be refreshed. The amounts above are the last loaded values.": "مش قادرين نحدث حالة المراجعة. المبالغ اللي فوق هي آخر قيم اتحملت.",
  "Refreshing…": "جاري التحديث…",
  "Refresh review status": "تحديث حالة المراجعة",
  "Step 2 of 2": "الخطوة ٢ من ٢",
  "Replace rejected receipt": "استبدال الإيصال المرفوض",
  "Create Receipt": "إنشاء إيصال",
  "Create First Receipt": "إنشاء أول إيصال",
  "Ready to Convert": "جاهز للتحويل لطالب",
  "Service-based invoice": "فاتورة خدمة",
  "Previous Receipt Rejected": "الإيصال السابق اترفض",
  "Payment Plan": "خطة الدفع",
  "Installment Details": "تفاصيل الأقساط",
  "Number of Installments": "عدد الأقساط",
  "Enter number of installments": "اكتب عدد الأقساط",
  "Installment Amount": "قيمة القسط",
  "The installment plan must match the agreed course total of": "خطة الأقساط لازم تطابق إجمالي الكورس المتفق عليه وهو",
  "Schedule dates are calculated after the receipt is created.": "مواعيد الأقساط بتتحسب بعد إنشاء الإيصال.",
  "Paid Amount": "المبلغ المدفوع",
  "Total Course Price": "إجمالي سعر الكورس",
  "Calculated from installments": "محسوب من الأقساط",
  "Cash price unavailable": "السعر الكاش مش متاح",
  "Total Price = number of installments × installment amount.": "السعر الإجمالي = عدد الأقساط × قيمة القسط.",
  "Configured course price.": "سعر الكورس المسجل.",
  "Cash course price is not configured.": "سعر الكورس الكاش مش متحدد.",
  "Payment Method": "طريقة الدفع",
  "Select payment method": "اختار طريقة الدفع",
  "Payment Account": "حساب الدفع",
  "Select account owner and account": "اختار صاحب الحساب والحساب",
  "Required Amount": "المبلغ المطلوب",
  "Remaining Amount (calculated)": "المبلغ المتبقي (محسوب)",
  "Receipt Photo": "صورة الإيصال",
  "(Contract review is handled by Senior Quality.)": "(مراجعة العقد مسؤولية سينيور الجودة.)",
  "Upload receipt photo": "رفع صورة الإيصال",
  "Click to replace": "اضغط للاستبدال",
  "JPG, PNG up to 5MB": "JPG أو PNG لحد 5MB",
  "Note": "ملاحظة",
  "Private payment comment": "تعليق دفع خاص",
  "(Reception only)": "(للاستقبال بس)",
  "Add payment verification details for Reception...": "ضيف تفاصيل التحقق من الدفع للاستقبال...",
  "Write-only here; never shown to Sales or Marketing.": "تقدر تكتبه هنا بس؛ مش بيظهر للسيلز أو التسويق.",
  "Creating Receipt...": "جاري إنشاء الإيصال...",
  "After creation, Marketing reviews the receipt first, then Reception confirms payment.": "بعد الإنشاء، التسويق بيراجع الإيصال الأول، وبعدها الاستقبال بيأكد الدفع.",
  "Link Referral": "ربط إحالة",
  "Save Referral": "حفظ الإحالة",
  "Link this lead to a referrer. Enter the Lead ID or Student ID of the person who referred them.": "اربط العميل بالشخص اللي رشحه. اكتب رقم العميل المحتمل أو رقم الطالب اللي رشحه.",
  "Referred by Lead ID": "رقم العميل اللي رشحه",
  "Enter Lead ID (e.g., 1234)": "اكتب رقم العميل (مثال: 1234)",
  "Referred by Student ID": "رقم الطالب اللي رشحه",
  "Enter Student ID (e.g., 5678)": "اكتب رقم الطالب (مثال: 5678)",
  "You can set one or both. To remove a referral, clear the field and save.": "تقدر تحدد واحد أو الاتنين. عشان تمسح إحالة، فضّي الحقل واحفظ.",
  "🔗 Registration Link": "🔗 رابط التسجيل",
  "Share this link with": "شارك الرابط ده مع",
  ". When they register using this link, they'll be automatically linked to this lead.": "لما يسجل بالرابط ده، هيتربط تلقائيًا بالعميل المحتمل ده.",
  "⏰ Expires:": "⏰ ينتهي:",
  "Copy message": "نسخ الرسالة",
  "Share via WhatsApp": "مشاركة عبر واتساب",
  "Offer": "العرض",
  "Contact Result": "نتيجة التواصل",
  "Channel": "قناة التواصل",
  "Select channel": "اختار قناة التواصل",
  "SMS": "رسالة SMS",
  "Conversation outcome": "نتيجة المحادثة",
  "Syncing interaction...": "جاري مزامنة التواصل...",
  "Pipeline Decision": "قرار مرحلة البيع",
  "Rejected is system-managed. It cannot be changed manually.": "حالة «مرفوض» بيديرها النظام. مينفعش تتغير يدويًا.",
  "✅ This lead is": "✅ العميل ده",
  "Move the stage as the conversation progresses. Receipt tools appear when the lead is qualified.": "حدّث المرحلة مع تقدم المحادثة. أدوات الإيصالات بتظهر لما العميل يبقى مؤهل.",
  "Select outcome": "اختار النتيجة",
  "Interested or Lost": "مهتم أو مش مكمل",
  "Lost": "مش مكمل",
  "Tags for": "وسوم لـ",
  "Select tag": "اختار وسم",
  "Next action date": "تاريخ الخطوة الجاية",
  "Select the reminder details, then save them below.": "اختار تفاصيل التذكير، وبعدها احفظها تحت.",
  "Next action": "الخطوة الجاية",
  "What needs to be done?": "إيه المطلوب يتعمل؟",
  "Save Next Action": "حفظ الخطوة الجاية",
  "Saving next action...": "جاري حفظ الخطوة الجاية...",
  "Reminder changes are not saved yet.": "تعديلات التذكير لسه مش محفوظة.",
  "Reminder is up to date.": "التذكير محدث.",
  "Offer course": "كورس العرض",
  "No mapped course found for this lead yet.": "لسه مفيش كورس مربوط بالعميل ده.",
  "Select a course to check curriculum PDF availability.": "اختار كورس عشان تراجع توفر ملف المنهج PDF.",
  "Marketing PDF is ready for this course.": "ملف التسويق جاهز للكورس ده.",
  "Open curriculum PDF": "فتح ملف المنهج PDF",
  "Missing marketing PDF for this course. Ask marketing to upload curriculum content.": "ملف التسويق مش موجود للكورس ده. اطلب من التسويق يرفع محتوى المنهج.",
  "Offer summary": "ملخص العرض",
  "Describe offered package, terms, and highlights": "اكتب تفاصيل الباقة والشروط وأهم مميزات العرض",
  "Payment mode": "نظام الدفع",
  "Down Payment (Paid Now)": "المقدم (مدفوع دلوقتي)",
  "e.g. 5000": "مثال: 5000",
  "First upfront amount paid before installment schedule starts.": "أول مبلغ مدفوع قبل بداية جدول الأقساط.",
  "e.g. 6": "مثال: 6",
  "Total number of recurring payments after the down payment.": "إجمالي عدد الدفعات الدورية بعد المقدم.",
  "Amount Per Installment": "قيمة كل قسط",
  "e.g. 2500": "مثال: 2500",
  "Amount charged each installment period.": "المبلغ المطلوب في كل فترة قسط.",
  "Installment Frequency": "دورية الأقساط",
  "e.g. monthly / every 30 days": "مثال: شهري / كل 30 يوم",
  "How often the installment amount is collected.": "كل قد إيه بيتحصل القسط.",
  "Installment Notes (Optional)": "ملاحظات الأقساط (اختياري)",
  "Any special terms (grace period, due date rules, penalties, etc.)": "أي شروط خاصة (فترة سماح، قواعد الاستحقاق، غرامات، وغيرها)",
  "Estimated total plan = down payment + (amount per installment × installment count) = {0} EGP": "إجمالي الخطة التقديري = المقدم + (قيمة القسط × عدد الأقساط) = {0} جنيه",
  "Estimated total plan = down payment + (amount per installment × installment count).": "إجمالي الخطة التقديري = المقدم + (قيمة القسط × عدد الأقساط).",
  "Proposal notes (optional)": "ملاحظات العرض (اختياري)",
  "Proposal Saved": "العرض اتحفظ",
  "Save Proposal": "حفظ العرض",
  "Once valid proposal fields are saved, stage auto-priority is Proposal Sent over meeting stage.": "بعد حفظ بيانات عرض صحيحة، مرحلة «العرض اتبعت» بتاخد أولوية تلقائيًا على مرحلة المقابلة.",
  "Move To Negotiation": "نقل للتفاوض",
  "Add negotiation notes manually (price objections, payment change requests, revised offers).": "ضيف ملاحظات التفاوض يدويًا (اعتراضات السعر، طلبات تغيير الدفع، العروض المعدلة).",
  "Negotiation details": "تفاصيل التفاوض",
  "Requested changes (optional)": "التغييرات المطلوبة (اختياري)",
  "Add Negotiation Note": "إضافة ملاحظة تفاوض",
  "First touch": "أول تواصل",
  "Handoff": "التسليم",
  "Exit": "خروج",
  "{0} copied": "{0} اتنسخ",
  "Unable to copy {0}": "مش قادرين ننسخ {0}",
  "Copy phone": "نسخ الرقم",
  "CRM Source": "مصدر العميل في CRM",
  "Last Contact": "آخر تواصل",
  "contact attempt(s)": "محاولة تواصل",
  "Last call:": "آخر مكالمة:",
  "Existing student {0}": "طالب موجود {0}",
  "Existing Student": "طالب موجود",
  "Tele-sales context": "تفاصيل المبيعات التليفونية",
  "Select campaign": "اختار حملة",
  "Lead Details": "تفاصيل العميل",
  "No additional lead details captured yet.": "لسه مفيش تفاصيل إضافية للعميل متسجلة.",
  "Enrolled": "التحق",
  "Pending Invoice": "فاتورة في الانتظار",
  "Has Invoice": "عنده فاتورة",
  "No course interests yet.": "لسه مفيش كورسات مهتم بيها.",
  "Referred by Lead #": "ترشيح من العميل #",
  "Referred by Student #": "ترشيح من الطالب #",
  "None linked": "مفيش إحالة مربوطة",
  "Opened": "اتفتح",
  "Not opened yet": "لسه متفتحش",
  "Opens:": "مرات الفتح:",
  "Registered: {0}": "التسجيل: {0}",
  "Last opened: {0}": "آخر فتح: {0}",
  "Generated: {0}": "اتعمل: {0}",
  "Last opened:": "آخر فتح:",
  "Generate Registration Link": "إنشاء رابط التسجيل",
  "Add sales notes, context, or next talking points...": "ضيف ملاحظات السيلز أو التفاصيل أو نقاط الكلام الجاية...",
  "Owner": "المسؤول",
  "Last contact": "آخر تواصل",
  "Lead overview": "ملخص العميل",
  "At a glance": "نظرة سريعة",
  "High priority": "أولوية عالية",
  "Not scheduled": "مش متحدد له ميعاد",
  "Reschedule follow-up": "تغيير ميعاد المتابعة",
  "Current Owner": "المسؤول الحالي",
  "Control": "إدارة",
  "Handoffs": "عمليات التسليم",
  "Latest Handoff": "آخر تسليم",
  "{0} course(s) available": "{0} كورس متاح",
  "Extra receipt available": "إيصال إضافي متاح",
  "One invoice per course": "فاتورة واحدة لكل كورس",
  "⚠️ Previous Invoice Rejected": "⚠️ الفاتورة السابقة اترفضت",
  "• Course: {0}": "• الكورس: {0}",
  "Courses with existing invoices:": "كورسات عندها فواتير بالفعل:",
  "(pending)": "(في الانتظار)",
  "All course interests already have invoices.": "كل الكورسات اللي العميل مهتم بيها عندها فواتير بالفعل.",
  "Create a one-off receipt for a new sales interest when needed.": "اعمل إيصال منفصل لاهتمام جديد بكورس وقت الحاجة.",
  "Contact reception for additional enrollments.": "تواصل مع الاستقبال بخصوص الاشتراكات الإضافية.",
  "Create one more receipt": "إنشاء إيصال إضافي",
  "Total course price": "إجمالي سعر الكورس",
  "Enter total course price": "اكتب إجمالي سعر الكورس",
  "Please select a course before creating a receipt": "اختار كورس قبل إنشاء إيصال",
  "Select a new course": "اختار كورس جديد",
  "Select from available courses": "اختار من الكورسات المتاحة",
  "Upload Receipt Photo": "رفع صورة الإيصال",
  "Create Additional Receipt": "إنشاء إيصال إضافي",
  "Create Receipt & Convert": "إنشاء إيصال وتحويل لطالب",
  "Facebook lead ID": "رقم عميل فيسبوك",
  "Lead created": "تاريخ إضافة العميل",
  "Ad account ID": "رقم حساب الإعلانات",
  "Campaign name": "اسم الحملة",
  "Ad set ID": "رقم المجموعة الإعلانية",
  "Ad set name": "اسم المجموعة الإعلانية",
  "Ad ID": "رقم الإعلان",
  "Ad name": "اسم الإعلان",
  "Form ID": "رقم النموذج",
  "Form name": "اسم النموذج",
  "Organic": "من غير إعلان مدفوع",
  "Facebook ad attribution": "مصدر إعلان فيسبوك",
  "Facebook ad details": "تفاصيل إعلان فيسبوك",
  "{0} fields": "{0} حقل",
  "Complete the interaction": "كمّل التواصل",
  "Select conversation outcome (Answered/No Answer)": "اختار نتيجة المحادثة (رد / مردش)",
  "Set next action date": "حدد تاريخ الخطوة الجاية",
  "Current attempt": "المحاولة الحالية",
  "This lead is closed": "العميل ده مقفول",
  "Continue registration & payment": "كمّل التسجيل والدفع",
  "The contact history is available in History. Use the authorized correction workflow if this lead needs to be reopened.": "سجل التواصل موجود في السجل. استخدم إجراء التصحيح المسموح لو العميل ده محتاج يتفتح تاني.",
  "This lead is {0}. Registration and receipt approvals control this stage.": "حالة العميل ده {0}. التسجيل وموافقات الإيصالات هما اللي بيحددوا المرحلة دي.",
  "Open registration & payment": "فتح التسجيل والدفع",
  "Choose the result, agree on the next step, then save once.": "اختار النتيجة، واتفق على الخطوة الجاية، وبعدها احفظ مرة واحدة.",
  "Loading saved contact…": "جاري تحميل التواصل المحفوظ…",
  "Demo details could not be loaded. Other contact results are available.": "مش قادرين نحمّل تفاصيل الديمو. نتائج التواصل التانية متاحة.",
  "Retry demo details": "إعادة تحميل تفاصيل الديمو",
  "Select Channel": "اختار قناة التواصل",
  "Choose how you contacted this lead.": "اختار الطريقة اللي اتواصلت بيها مع العميل ده.",
  "No answer": "مردش",
  "Not interested": "مش مهتم",
  "Next step": "الخطوة الجاية",
  "Selected Course": "الكورس المختار",
  "Add another course": "إضافة كورس تاني",
  "Additional Course": "كورس إضافي",
  "Follow up": "متابعة",
  "Book demo": "حجز ديمو",
  "Save this contact to continue to the registration link and receipt. This does not mark the customer as registered or paid.": "احفظ التواصل ده عشان تكمّل لرابط التسجيل والإيصال. ده مش بيعتبر العميل مسجل أو مدفوع.",
  "This comment will be saved with the selected contact attempt.": "التعليق ده هيتحفظ مع محاولة التواصل المختارة.",
  "Save & continue to registration": "حفظ وتكملة للتسجيل",
  "Save result": "حفظ النتيجة",
  "Discard draft": "تجاهل المسودة",
  "Next Action Date": "تاريخ الخطوة الجاية",
  "Next Action Time": "وقت الخطوة الجاية",
  "Consultation selections updated": "اختيارات الاستشارة اتحدثت",
  "Course, place, date, and time are required for private appointment": "الكورس والمكان والتاريخ والوقت مطلوبين للموعد الخاص",
  "Private appointment added to reception queue": "الموعد الخاص اتضاف لطابور الاستقبال",
  "Complete offer and payment fields before saving proposal": "كمّل بيانات العرض والدفع قبل حفظ العرض",
  "Proposal saved": "العرض اتحفظ",
  "Add negotiation details first": "ضيف تفاصيل التفاوض الأول",
  "Negotiation note added": "ملاحظة التفاوض اتضافت",
  "Unable to load cycle": "مش قادرين نحمّل دورة المتابعة",
  "Priority updated to {0}": "الأولوية اتحدثت إلى {0}",
  "Failed to update priority": "تحديث الأولوية فشل",
  "Cannot manually change status from {0}. This status is locked.": "مينفعش تغير الحالة يدويًا من {0}. الحالة دي مقفولة.",
  "Rejected status is system-managed and cannot be changed manually.": "حالة «مرفوض» بيديرها النظام ومينفعش تتغير يدويًا.",
  "Please select a tag for \"{0}\" before moving this lead.": "اختار وسم لـ «{0}» قبل نقل العميل ده.",
  "Status updated to {0}": "الحالة اتحدثت إلى {0}",
  "Tags updated": "الوسوم اتحدثت",
  "Interaction logged": "التواصل اتسجل",
  "A tag is required for \"{0}\".": "لازم وسم لـ «{0}».",
  "Note saved": "الملاحظة اتحفظت",
  "Please choose next action date and time before saving": "اختار تاريخ ووقت الخطوة الجاية قبل الحفظ",
  "Next action saved": "الخطوة الجاية اتحفظت",
  "This Lead still needs a saved reminder or work result before you leave.": "العميل ده لسه محتاج تذكير محفوظ أو نتيجة شغل قبل ما تخرج.",
  "Save or discard the contact draft before leaving.": "احفظ مسودة التواصل أو تجاهلها قبل الخروج.",
  "Please save the next action reminder before closing": "احفظ تذكير الخطوة الجاية قبل الإغلاق",
  "Please select conversation outcome and set next action date before closing": "اختار نتيجة المحادثة وحدد تاريخ الخطوة الجاية قبل الإغلاق",
  "No course found for this lead.": "ملقيناش كورس للعميل ده.",
  "Academy Record": "سجل الأكاديمية",
  "Student Stage": "مرحلة الطالب",
  "Course State": "حالة الكورس",
  "Student Courses": "كورسات الطالب",
  "Update stage outcome": "تحديث نتيجة المرحلة",
  "Log contact": "تسجيل تواصل",
  "Register & pay": "التسجيل والدفع",
  "Edit lead details": "تعديل تفاصيل العميل",
  "Close lead details": "إغلاق تفاصيل العميل",
  "Lead workspace": "مساحة شغل العميل",
  "Result captured": "النتيجة اتسجلت",
  "{0} mode": "وضع {0}",
  "Continue with this lead or move to the next one.": "كمّل مع العميل ده أو روح للعميل اللي بعده.",
  "Log the contact result and agree on the next step before continuing.": "سجل نتيجة التواصل واتفق على الخطوة الجاية قبل ما تكمّل.",
  "Choose result": "اختار النتيجة",
  "Next lead: {0}": "العميل الجاي: {0}",
  "Transfer request submitted": "طلب التحويل اتبعت",
  "Need review submitted": "طلب المراجعة اتبعت",
  "Save a result before leaving": "احفظ نتيجة قبل الخروج",
  "This lead was opened from": "العميل ده اتفتح من",
  ". Capture one sales result so it does not return to the queue unchanged.": "سجل نتيجة سيلز واحدة عشان ميرجعش للطابور من غير تغيير.",
  "Move stage / outcome": "نقل المرحلة / النتيجة",
  "WhatsApp result": "نتيجة واتساب",
  "Log contact result": "تسجيل نتيجة التواصل",
  "Pipeline stages": "مراحل البيع",
  "No matching leads": "مفيش عملاء مطابقين",
  "Leads": "العملاء المحتملين",
  "Last month": "الشهر اللي فات",
  "Select month": "اختار شهر",
  "Select date": "اختار تاريخ",
  "Choose original entry date": "اختار تاريخ الإضافة الأصلي",
  "Original entry from": "تاريخ الإضافة الأصلي من",
  "Original entry to": "تاريخ الإضافة الأصلي لحد",
  "Original Lead Entry Date": "تاريخ إضافة العميل الأصلي",
  "Original Lead Entry Date: {0}": "تاريخ إضافة العميل الأصلي: {0}",
  "Overdue follow-ups": "متابعات متأخرة",
  "Showing": "عرض",
  "Team": "الفريق",
  "Due today": "مستحق النهارده",
  "Saved": "اتحفظ",
  "System": "النظام",
  "No notifications right now.": "مفيش إشعارات دلوقتي.",
  "You are all caught up.": "كل الإشعارات اتراجعت.",
  "Notifications": "الإشعارات",
  "Preferences": "التفضيلات",
  "Enable Push": "تفعيل الإشعارات الفورية",
  "Mark as Read": "تحديد كمقروء",
  "Notification Preferences": "تفضيلات الإشعارات",
  "Enable browser notifications": "تفعيل إشعارات المتصفح",
  "Follow-up reminders": "تذكيرات المتابعة",
  "New lead assigned": "عميل جديد اتعيّن لك",
  "WhatsApp messages": "رسائل واتساب",
  "Transfer request updates": "تحديثات طلبات التحويل",
  "Need review updates": "تحديثات طلبات المراجعة",
  "Open Lead": "فتح العميل",
  "New untouched": "جديد ولسه متفتحش",
  "Hot leads": "عملاء مهتمين جدًا",
  "Total leads": "إجمالي العملاء",
  "Hot opportunities": "فرص قوية",
  "Open navigation": "فتح التنقل",
  "Lead Pipeline": "مراحل بيع العملاء",
  "Move leads through the sales journey, recover overdue follow-ups, and open each record without losing your place in the pipeline.": "تابع تقدم العملاء في رحلة البيع، ولحق المتابعات المتأخرة، وافتح كل سجل من غير ما تفقد مكانك في مراحل البيع.",
  "Refreshing now": "جاري التحديث دلوقتي",
  "Updated from live CRM": "اتحدث من بيانات CRM الحالية",
  "Refresh pipeline": "تحديث مراحل البيع",
  "Pipeline controls": "أدوات مراحل البيع",
  "Search pipeline leads": "دور في عملاء مراحل البيع",
  "Pipeline view": "عرض مراحل البيع",
  "Board view": "عرض اللوحة",
  "Board": "اللوحة",
  "Stage Focus view": "عرض مرحلة واحدة",
  "Stage Focus": "مرحلة واحدة",
  "View options: {0}": "خيارات العرض: {0}",
  "Load older leads": "تحميل عملاء أقدم",
  "Load older": "تحميل أقدم",
  "Pipeline surfaces": "طرق عرض مراحل البيع",
  "Work Queue": "طابور الشغل",
  "urgent ·": "عاجل ·",
  "due": "مستحق",
  "Quick filters": "فلاتر سريعة",
  "Pipeline workspace": "مساحة مراحل البيع",
  "Pipeline summary": "ملخص مراحل البيع",
  "Focus {0} stage": "عرض مرحلة {0}",
  "due ·": "مستحق ·",
  "without follow-up": "من غير متابعة",
  "Work queue": "طابور الشغل",
  "Filters": "الفلاتر",
  "View options": "خيارات العرض",
  "{0} cards": "{0} كارت",
  "View": "عرض",
  "Back to pipeline": "رجوع لمراحل البيع",
  "My follow-ups": "متابعاتي",
  "New lead": "عميل جديد",
  "{0} summary": "ملخص {0}",
  "{0} allocated now{1}. Counts cover all pages.": "{0} متوزع دلوقتي{1}. الأعداد بتشمل كل الصفحات.",
  "of {0} slots across {1} active sales employees": "من {0} مكان عند {1} موظف سيلز نشط",
  "New enquiries": "استفسارات جديدة",
  "New leads captured and awaiting first contact.": "عملاء جدد اتسجلوا ومستنيين أول تواصل.",
  "Imported leads": "عملاء مستوردين",
  "Leads imported from previous campaigns or historical data.": "عملاء اتضافوا من حملات قديمة أو بيانات سابقة.",
  "No reply": "مردش",
  "Follow-up is needed after an unanswered contact.": "محتاج متابعة بعد محاولة تواصل من غير رد.",
  "Contacted and answered. Qualification in progress.": "اتواصلنا معاه ورد. التأهيل جاري.",
  "Follow-up": "متابعة",
  "Proposal, negotiation, and scheduled follow-up in progress.": "العرض والتفاوض والمتابعة المحددة لسه شغالين.",
  "Course demo": "ديمو الكورس",
  "Product demo scheduled or completed.": "ديمو الكورس متحدد أو اكتمل.",
  "Customer completed the registration form. Receipt can now be created.": "العميل كمّل استمارة التسجيل. تقدر تعمل إيصال دلوقتي.",
  "Payment review": "مراجعة الدفع",
  "Receipt created. Awaiting Marketing then Reception confirmation.": "الإيصال اتعمل. في انتظار تأكيد التسويق وبعده الاستقبال.",
  "Pipeline stage available in the current workflow.": "مرحلة بيع متاحة في خطوات الشغل الحالية.",
  "Registration is system-managed": "التسجيل بيديره النظام",
  "Registered is created by the student registration path so reports and reception stay consistent.": "حالة «مسجل» بتتحدد من مسار تسجيل الطالب عشان التقارير والاستقبال يفضلوا متوافقين.",
  "Enrollment is system-managed": "الالتحاق بيديره النظام",
  "Enrolled is created by the accepted receipt and accounting path.": "حالة «التحق» بتتحدد من قبول الإيصال ومسار الحسابات.",
  "Payment is system-managed": "الدفع بيديره النظام",
  "Paid is set after the payment and receipt workflow confirms the transaction.": "حالة «مدفوع» بتتحدد بعد ما خطوات الدفع والإيصال تأكد المعاملة.",
  "Rejected is invoice-managed": "حالة الرفض بتتحدد من الفاتورة",
  "Rejected is set by invoice review workflows so finance history stays auditable.": "حالة «مرفوض» بتتحدد من مراجعة الفواتير عشان سجل الحسابات يفضل قابل للمراجعة.",
  "Close with outcome": "إغلاق بنتيجة",
  "Lost needs a clear outcome reason. Use the outcome modal instead of a blind board move.": "حالة «مش مكمل» محتاجة سبب واضح. استخدم نافذة النتيجة بدل نقل الكارت من غير سبب.",
  "No stage change": "المرحلة متغيرتش",
  "Drop on a different stage to move the lead.": "اسحب العميل لمرحلة مختلفة عشان تنقله.",
  "New Lead is system-managed": "مرحلة «عميل جديد» بيديرها النظام",
  "Log a first contact outcome before moving this lead out of New Lead.": "سجل نتيجة أول تواصل قبل نقل العميل من مرحلة «عميل جديد».",
  "New Lead is intake-only": "مرحلة «عميل جديد» للاستلام الأول بس",
  "New Lead is reserved for fresh intake. Use a workflow action if the lead needs to be reopened.": "مرحلة «عميل جديد» مخصصة للعملاء الجدد. استخدم إجراء الشغل المناسب لو محتاج تفتح العميل تاني.",
  "Stage tag required": "وسم المرحلة مطلوب",
  "Review stage move": "مراجعة نقل المرحلة",
  "Active Funnel": "مراحل البيع النشطة",
  "Closed / System": "المقفول / النظام",
  "Daily Work": "الشغل اليومي",
  "Work Now plus active funnel only.": "طابور «اشتغل دلوقتي» ومراحل البيع النشطة بس.",
  "Active sales stages without closed records.": "مراحل البيع النشطة من غير السجلات المقفولة.",
  "Imported backlog": "بيانات مستوردة سابقة",
  "Imported and historical leads, separate from the daily sales stages.": "عملاء مستوردين وقدام، منفصلين عن مراحل البيع اليومية.",
  "Closed/System": "المقفول / النظام",
  "Paid and Lost closed stages.": "المراحل المقفولة: مدفوع ومش مكمل.",
  "Payment Pending awaits approval; Paid and Lost are closed records.": "الدفع قيد المراجعة لسه مستني الاعتماد؛ مدفوع ومش مكمل حالات مقفولة.",
  "All visible": "كل الظاهر",
  "Show every lead currently visible in the queue. Search finds other assigned leads.": "عرض كل عميل ظاهر حاليًا في الطابور. البحث بيلاقي العملاء التانيين المتعيّنين لك.",
  "Overdue follow-up": "متابعة متأخرة",
  "Pending WhatsApp": "واتساب في الانتظار",
  "No next action": "من غير خطوة جاية",
  "Tele-sales Queue": "طابور المبيعات التليفونية",
  "Conversations": "المحادثات",
  "My workspace": "مساحة شغلي",
  "My Work": "شغلي",
  "Targets": "الأهداف",
  "Course Assignments": "توزيع الكورسات",
  "Manager Controls": "أدوات المدير",
  "Landing Stage": "مرحلة البداية",
  "Required Fields": "الحقول المطلوبة",
  "Available Context": "التفاصيل المتاحة",
  "Sort Plan": "ترتيب العرض",
  "Pipeline Scope": "نطاق مراحل البيع",
  "Course / Tag Context": "تفاصيل الكورس / الوسم",
  "Owner Scope": "نطاق المسؤول",
  "Card Density": "حجم الكروت",
  "Visible Fields": "الحقول الظاهرة",
  "Sales operations": "عمليات السيلز",
  "Sources": "المصادر",
  "Lead Movement": "حركة العملاء",
  "Lead Movement sections": "أقسام حركة العملاء",
  "Loading follow-ups…": "جاري تحميل المتابعات…",
  "My activity": "نشاطي",
  "Loading activity…": "جاري تحميل النشاط…",
  "My target & earnings": "هدفي ومستحقاتي",
  "My work": "شغلي",
  "One lead at a time. Make contact, save the result, and plan the next step.": "عميل واحد كل مرة. اتواصل معاه، احفظ النتيجة، وحدد الخطوة الجاية.",
  "Newest created": "الأحدث إضافة",
  "Oldest created": "الأقدم إضافة",
  "Follow-up due first": "المتابعة الأقرب الأول",
  "Last activity newest": "أحدث نشاط الأول",
  "Last activity": "آخر نشاط",
  "Loading sales pipeline": "جاري تحميل مراحل البيع",
  "Preparing your live sales journey and follow-up queues.": "جاري تجهيز رحلة البيع الحالية وطوابير المتابعة.",
  "Loading pipeline data…": "جاري تحميل بيانات مراحل البيع…",
  "0 of 0": "0 من 0",
  "Work now queue": "طابور الشغل الحالي",
  "Work Now": "اشتغل دلوقتي",
  "Overdue, pending WhatsApp, due today, and leads with no next action.": "المتأخر، وواتساب في الانتظار، والمستحق النهارده، والعملاء من غير خطوة جاية.",
  "{0} urgent of {1}": "{0} عاجل من {1}",
  "Work now reason counts": "أعداد أسباب الشغل الحالي",
  "No urgent leads in the current view.": "مفيش عملاء عاجلين في العرض الحالي.",
  "Work Now pagination": "صفحات طابور الشغل الحالي",
  "Loading completion queue": "جاري تحميل طابور الإنجاز",
  "Completion queue unavailable": "طابور الإنجاز مش متاح",
  "Completion queue": "طابور الإنجاز",
  "Completion Queue": "طابور الإنجاز",
  "Customers with actions due today.": "عملاء عندهم إجراءات مستحقة النهارده.",
  "remaining": "متبقي",
  "Show queue": "عرض الطابور",
  "Hide queue": "إخفاء الطابور",
  "Completion queue owner counts": "أعداد المسؤولين في طابور الإنجاز",
  "No status": "من غير حالة",
  "Completing…": "جاري الإكمال…",
  "No actions are due today.": "مفيش إجراءات مستحقة النهارده.",
  "Completion Queue pagination": "صفحات طابور الإنجاز",
  "Load More": "تحميل المزيد",
  "Enter a valid phone number": "اكتب رقم تليفون صحيح",
  "Current action completed": "الإجراء الحالي اكتمل",
  "Start date must be before or equal to end date": "تاريخ البداية لازم يكون قبل تاريخ النهاية أو نفس اليوم",
  "Lead moved to {0}": "العميل اتنقل إلى {0}",
  "{0} - Approved Student (Code: {1})": "{0} - طالب معتمد (الكود: {1})",
  "Lead \"{0}\" already exists (ID {1}).": "العميل «{0}» موجود بالفعل (رقم {1}).",
  "Lead already exists (ID {0}).": "العميل موجود بالفعل (رقم {0}).",
  "Failed to create lead": "إنشاء العميل فشل",
  "Lead \"{0}\" created successfully": "العميل «{0}» اتضاف بنجاح",
  "Lead addition request updated and resubmitted for manager approval.": "طلب إضافة العميل اتعدل واتقدم تاني لموافقة المدير.",
  "Lead addition request submitted successfully and is waiting for manager approval.": "طلب إضافة العميل اتقدم بنجاح ومستني موافقة المدير.",
  "Unable to refresh the pipeline": "مش قادرين نحدث مراحل البيع",
  "Active pipeline filters": "فلاتر مراحل البيع الحالية",
  "Dismiss pipeline filters backdrop": "إغلاق خلفية فلاتر مراحل البيع",
  "Pipeline Filters": "فلاتر مراحل البيع",
  "Choose courses, owners and contact results. Dates filter when leads were added.": "اختار الكورسات والمسؤولين ونتائج التواصل. التواريخ بتفلتر وقت إضافة العملاء.",
  "Close pipeline filters": "إغلاق فلاتر مراحل البيع",
  "Lead scope": "نطاق العملاء",
  "Quick filter": "فلتر سريع",
  "All leads": "كل العملاء",
  "Sort Leads": "ترتيب العملاء",
  "Stages": "المراحل",
  "All stages": "كل المراحل",
  "All Tags": "كل الوسوم",
  "Added date — either end can be left blank.": "تاريخ الإضافة — تقدر تسيب أي طرف فاضي.",
  "Filter by Employee": "فلترة بالموظف",
  "Campaign filters": "فلاتر الحملات",
  "Filter by Campaign": "فلترة بالحملة",
  "All Campaigns": "كل الحملات",
  "{0} selected filter options": "{0} اختيار فلتر محدد",
  "No active filters": "مفيش فلاتر شغالة",
  "Dismiss view options backdrop": "إغلاق خلفية خيارات العرض",
  "View Options": "خيارات العرض",
  "Control lead card details.": "اختار تفاصيل كارت العميل.",
  "Close view options": "إغلاق خيارات العرض",
  "Compact Cards": "كروت مختصرة",
  "Fit more leads per stage": "عملاء أكتر في كل مرحلة",
  "Comfortable Cards": "كروت واسعة",
  "More breathing room": "مساحة أوسع",
  "Show": "عرض",
  "Pipeline update failed": "تحديث مراحل البيع فشل",
  "Your last loaded pipeline is still available below.": "آخر بيانات مراحل البيع اتحملت لسه متاحة تحت.",
  "Work queue surface": "عرض طابور الشغل",
  "Work Now and Completion Queue are kept together here so the pipeline stays focused.": "طابور «اشتغل دلوقتي» وطابور الإنجاز موجودين مع بعض هنا عشان مراحل البيع تفضل واضحة.",
  "urgent": "عاجل",
  "due today": "مستحق النهارده",
  "Show Work Now": "عرض الشغل الحالي",
  "Hide Work Now": "إخفاء الشغل الحالي",
  "Sales pipeline workspace": "مساحة شغل مراحل البيع",
  "Pipeline Board": "لوحة مراحل البيع",
  "Scroll across stages. Select a summary to focus.": "اتحرك بين المراحل. اختار ملخص عشان تركز على مرحلة.",
  "Pipeline queue": "طابور مراحل البيع",
  "All allocated": "كل المتوزع",
  "Scheduled later": "محدد لوقت لاحق",
  "results": "نتائج",
  "available": "متاح",
  "Comfortable": "واسعة",
  "cards": "كروت",
  "Pipeline empty state": "حالة مراحل البيع الفاضية",
  "No leads yet": "لسه مفيش عملاء",
  "The pipeline is ready for its first lead.": "مراحل البيع جاهزة لأول عميل.",
  "Stage movement review": "مراجعة نقل المرحلة",
  "Stage move route": "مسار نقل المرحلة",
  "Add New Lead": "إضافة عميل جديد",
  "Close add lead": "إغلاق إضافة العميل",
  "Returned requests need editing": "الطلبات المرجّعة محتاجة تعديل",
  "Editing": "جاري التعديل",
  "Edit Request": "تعديل الطلب",
  "Please enter the lead name": "اكتب اسم العميل",
  "Enter full name": "اكتب الاسم بالكامل",
  "Please enter a phone number": "اكتب رقم تليفون",
  "e.g., 01012345678": "مثال: 01012345678",
  "View Customer": "عرض العميل",
  "email@example.com": "email@example.com",
  "e.g., Cairo, Giza, etc.": "مثال: القاهرة، الجيزة، وغيرها",
  "Please select an interested course": "اختار كورس العميل مهتم بيه",
  "Select a course": "اختار كورس",
  "Please select the actual lead source": "اختار المصدر الفعلي للعميل",
  "Add any initial notes...": "ضيف أي ملاحظات مبدئية...",
  "Resubmit for Approval": "إعادة تقديم للموافقة",
  "Share": "مشاركة",
  "Target Progress": "التقدم في الهدف",
  "Sales Reports": "تقارير السيلز",
  "Monthly team sales and target analytics.": "تحليل مبيعات الفريق والأهداف الشهرية.",
  "Report Month": "شهر التقرير",
  "Failed to load reports": "تحميل التقارير فشل",
  "Team Target": "هدف الفريق",
  "Gross Sales": "إجمالي المبيعات",
  "Team Progress": "تقدم الفريق",
  "Target Gap": "المتبقي للهدف",
  "Collection Capture": "التحصيل المسجل",
  "Top Course": "أعلى كورس",
  "No sales yet": "لسه مفيش مبيعات",
  "Team Sales by Course and Payment Method": "مبيعات الفريق حسب الكورس وطريقة الدفع",
  "No team sales data for this month.": "مفيش بيانات مبيعات للفريق في الشهر ده.",
  "Employees On Target": "موظفين حققوا الهدف",
  "Sales Count": "عدد المبيعات",
  "Remaining to Target": "المتبقي للهدف",
  "Sales Target Analytics": "تحليل أهداف المبيعات",
  "No target analytics data for this month.": "مفيش بيانات تحليل أهداف في الشهر ده.",
  "Average Progress": "متوسط التقدم",
  "Below 50%": "أقل من 50%",
  "Without Target": "من غير هدف",
  "Employees With Target": "موظفين عندهم هدف",
  "Target Bands": "شرائح تحقيق الهدف",
  "Band": "الشريحة",
  "Courses vs Target": "الكورسات مقارنة بالهدف",
  "Payment Mix vs Target": "توزيع طرق الدفع مقارنة بالهدف",
  "Search or add tag...": "دور على وسم أو ضيف واحد...",
  "Add \"": "إضافة «",
  "No matching tags": "مفيش وسوم مطابقة",
  "Workflow tags saved": "وسوم الشغل اتحفظت",
  "Failed to update workflow tags": "تحديث وسوم الشغل فشل",
  "Sales Settings": "إعدادات السيلز",
  "Manage the workflow tags used by the sales team.": "إدارة وسوم الشغل اللي بيستخدمها فريق السيلز.",
  "Unsaved changes": "تعديلات مش محفوظة",
  "Sales settings summary": "ملخص إعدادات السيلز",
  "active tags": "وسم نشط",
  "Last update": "آخر تحديث",
  "Failed to load workflow tags": "تحميل وسوم الشغل فشل",
  "Workflow tags": "وسوم الشغل",
  "Pipeline labels": "مسميات مراحل البيع",
  "These tags appear inside lead cards, tasks, and pipeline filters.": "الوسوم دي بتظهر في كروت العملاء والمهام وفلاتر مراحل البيع.",
  "Draft changed": "المسودة اتعدلت",
  "No editable stages available": "مفيش مراحل متاحة للتعديل",
  "{0} tags": "{0} وسم",
  "No tags yet": "لسه مفيش وسوم",
  "Add tags for {0}": "إضافة وسوم لـ {0}",
  "Team Review": "مراجعة الفريق",
  "{0}, {1} work now": "{0}، {1} شغل دلوقتي",
  "Collapse navigation": "تصغير التنقل",
  "Expand navigation": "توسيع التنقل",
  "Sales help": "مساعدة السيلز",
  "Open the Sales help guide": "افتح دليل مساعدة السيلز",
  "Help": "مساعدة",
  "Sales User": "مستخدم سيلز",
  "Active now": "نشط دلوقتي",
  "Sign out": "تسجيل الخروج",
  "Sign out of your account?": "تخرج من حسابك؟",
  "Targets & earnings": "الأهداف والمستحقات",
  "← Back to targets": "← رجوع للأهداف",
  "Loading team…": "جاري تحميل الفريق…",
  "Sales Team workspace": "مساحة فريق السيلز",
  "Team & targets": "الفريق والأهداف",
  "Due {0}": "مستحق {0}",
  "Best next action:": "أفضل خطوة جاية:",
  "Open Tasks": "فتح المهام",
  "normal": "عادية",
  "Next:": "التالي:",
  "Last:": "السابق:",
  "Open Pipeline": "فتح مراحل البيع",
  "This focus item is unavailable in the current queue response.": "البند ده مش متاح في بيانات الطابور الحالية.",
  "No focus work right now.": "مفيش شغل محتاج تركيز دلوقتي.",
  "Why this is next": "ليه دي الخطوة الجاية",
  "Open lead workspace": "فتح مساحة شغل العميل",
  "Skip": "تخطي",
  "Sales workspace ·": "مساحة شغل السيلز ·",
  "Only the work that needs a salesperson decision now.": "الشغل اللي محتاج قرار من موظف السيلز دلوقتي بس.",
  "Start Working": "ابدأ الشغل",
  "Some Sales data could not load": "بعض بيانات السيلز متحملتش",
  "You can keep working from loaded sections. New updates will appear automatically when the connection recovers.": "تقدر تكمّل من الأقسام اللي اتحملت. التحديثات الجديدة هتظهر تلقائيًا لما الاتصال يرجع.",
  "Today action summary": "ملخص إجراءات النهارده",
  "total": "الإجمالي",
  "First touches": "أول تواصل",
  "Needs decision": "محتاج قرار",
  "No urgent work right now.": "مفيش شغل عاجل دلوقتي.",
  "Every visible new lead has a first contact or is already in Work now.": "كل عميل جديد ظاهر عنده أول تواصل أو موجود بالفعل في طابور الشغل الحالي.",
  "No hot leads outside first touch.": "مفيش عملاء مهتمين جدًا خارج أول تواصل.",
  "No extra decisions waiting.": "مفيش قرارات إضافية مستنية.",
  "No more scheduled follow-ups for today.": "مفيش متابعات محددة تانية للنهارده.",
  "Opening lead #": "جاري فتح العميل #",
  "No changes to save": "مفيش تغييرات للحفظ",
  "Lead updated successfully": "بيانات العميل اتحدثت بنجاح",
  "Lead created successfully": "العميل اتضاف بنجاح",
  "An error occurred": "حصل خطأ",
  "Email (optional)": "الإيميل (اختياري)",
  "Location (optional)": "المكان (اختياري)",
  "Create Lead": "إضافة عميل",
  "Bulk Complete": "إكمال المحدد",
  "Bulk Snooze": "تأجيل المحدد",
  "Bulk Reschedule": "تغيير مواعيد المحدد",
  "Assign Need Review": "تعيين للمراجعة",
  "Clear Selection": "إلغاء التحديد",
  "Complete Task": "إكمال المهمة",
  "This task closes when:": "المهمة دي بتتقفل لما:",
  "What happened?": "إيه اللي حصل؟",
  "What happened? *": "إيه اللي حصل؟ *",
  "Save follow-up": "حفظ المتابعة",
  "Next contact date *": "تاريخ التواصل الجاي *",
  "Next contact date": "تاريخ التواصل الجاي",
  "Choose date": "اختار تاريخ",
  "Time *": "الوقت *",
  "Next contact time": "وقت التواصل الجاي",
  "Choose time": "اختار وقت",
  "Snooze Task": "تأجيل المهمة",
  "Snooze": "تأجيل",
  "Remind me on *": "فكرني في *",
  "Snooze date": "تاريخ التأجيل",
  "Snooze time": "وقت التأجيل",
  "Complete with a note": "إكمال مع ملاحظة",
  "On track": "ماشي حسب الخطة",
  "Fresh overdue (": "متأخر جديد (",
  "h)": "ساعة)",
  "Old (": "قديم (",
  "d)": "يوم)",
  "Stale (": "من غير نشاط (",
  "Cleanup (": "للمراجعة والتنظيف (",
  "Select work for {0}": "اختار شغل {0}",
  "First conversation": "أول محادثة",
  "· Last touch {0}": "· آخر تواصل {0}",
  "Work on lead": "اشتغل على العميل",
  "WA": "واتساب",
  "Due Time (Earliest)": "ميعاد الاستحقاق (الأقرب)",
  "Due Time (Latest)": "ميعاد الاستحقاق (الأبعد)",
  "Priority (High-Low)": "الأولوية (الأعلى للأقل)",
  "Aging (Most overdue)": "مدة التأخير (الأكتر تأخرًا)",
  "Stage (A-Z)": "المرحلة (أبجديًا)",
  "Last Activity (Latest)": "آخر نشاط (الأحدث)",
  "Quick Filter": "فلتر سريع",
  "Hot Leads": "عملاء مهتمين جدًا",
  "Payment Follow-up": "متابعة الدفع",
  "No Answer Retry": "إعادة المحاولة بعد عدم الرد",
  "Due Now": "مستحق دلوقتي",
  "Overdue Today": "متأخر النهارده",
  "Stale Tasks": "مهام من غير نشاط",
  "Search follow-ups": "دور في المتابعات",
  "Search lead, phone, task": "دور بالعميل أو الرقم أو المهمة",
  "Sort follow-ups": "ترتيب المتابعات",
  "Stage filter": "فلتر المرحلة",
  "Task type filter": "فلتر نوع المهمة",
  "Priority filter": "فلتر الأولوية",
  "Source filter": "فلتر المصدر",
  "Campaign filter": "فلتر الحملة",
  "Aging filter": "فلتر مدة التأخير",
  "Aging": "مدة التأخير",
  "<24h": "أقل من 24 ساعة",
  "1-7d": "1–7 أيام",
  ">7d": "أكتر من 7 أيام",
  ">30d": "أكتر من 30 يوم",
  "Critical": "حرجة",
  "Task completed": "المهمة اكتملت",
  "Submit Need Review Requests": "إرسال طلبات المراجعة",
  "Need review submitted from task queue": "طلب المراجعة اتبعت من طابور المهام",
  "Your daily queue": "طابورك اليومي",
  "actions in this view · New leads and follow-ups assigned to you": "إجراء في العرض ده · عملاء جدد ومتابعات متعيّنين لك",
  "Showing {0} loaded actions. This is a partial workload view.": "عرض {0} إجراء اتحمل. العرض ده جزء من الشغل كله.",
  "Showing {0} loaded actions from {1} identified actions.": "عرض {0} إجراء اتحمل من {1} إجراء معروف.",
  "Large queues are limited. Complete work and refresh to load remaining actions; use My leads to find any assigned lead. Tab counts reflect loaded actions.": "الطوابير الكبيرة ليها حد للتحميل. خلّص شغل وحدّث عشان تحمّل الإجراءات الباقية؛ استخدم «عملائي» عشان تلاقي أي عميل متعيّن لك. أعداد التبويبات بتعكس الإجراءات اللي اتحملت.",
  "Failed to load daily queue": "تحميل الطابور اليومي فشل",
  "Your queue could not be loaded": "مش قادرين نحمّل طابورك",
  "No actions in this view": "مفيش إجراءات في العرض ده",
  "Retry to check your assigned work.": "جرّب تاني عشان تراجع الشغل المتعيّن لك.",
  "Check the other tabs or clear filters. New leads and scheduled follow-ups appear here automatically.": "راجع التبويبات التانية أو امسح الفلاتر. العملاء الجدد والمتابعات المحددة بيظهروا هنا تلقائيًا.",
  "Submit review request?": "تبعت طلب المراجعة؟",
  "tasks.": "مهمة.",
  "still queued.": "لسه في الطابور.",
  "Needs action first": "محتاج إجراء الأول",
  "Due Today": "مستحق النهارده",
  "Scheduled for today": "محدد للنهارده",
  "Late Risk": "خطر التأخير",
  "High priority overdue": "متأخر بأولوية عالية",
  "Next planned work": "الشغل المخطط الجاي",
  "Queue views": "طرق عرض الطابور",
  "Open lead": "فتح العميل",
  "Tele-sales handoff": "تسليم المبيعات التليفونية",
  "Close navigation": "إغلاق التنقل",
  "Lead opened": "العميل اتفتح",
  "Lead details opened by employee": "الموظف فتح تفاصيل العميل",
  "First Contact": "أول تواصل",
  "Course Details": "تفاصيل الكورس",
  "Wrong Number": "رقم غلط",
  "Needs Follow-up": "محتاج متابعة",
  "Proposal Sent": "العرض اتبعت",
  "Meeting Scheduled": "مقابلة محددة",
  "Negotiation": "تفاوض",
  "No follow-up": "من غير متابعة",
  "Note added": "ملاحظة اتضافت",
  "Follow-up created": "متابعة اتعملت",
  "Call clicked": "اتضغط على اتصال",
  "WhatsApp opened": "واتساب اتفتح",
  "Email sent": "الإيميل اتبعت",
  "WhatsApp outcome saved": "نتيجة واتساب اتحفظت",
  "WhatsApp message copied": "رسالة واتساب اتنسخت",
  "Review outcome": "مراجعة النتيجة",
  "Call now": "اتصل دلوقتي",
  "Reschedule": "تغيير الميعاد",
  "Pending WhatsApp follow-up": "متابعة واتساب في الانتظار",
  "Reply on WhatsApp or log the outcome before this lead leaves Work Now.": "رد على واتساب أو سجل النتيجة قبل ما العميل ده يخرج من طابور الشغل الحالي.",
  "Reply WhatsApp": "رد على واتساب",
  "No follow-up scheduled": "مفيش متابعة محددة",
  "Set a dated commitment before leaving this lead.": "حدد خطوة بميعاد قبل ما تسيب العميل ده.",
  "Follow-up due today": "متابعة مستحقة النهارده",
  "Activity gap": "فترة من غير نشاط",
  "This lead has no recent contact. Reopen the conversation or ask for review.": "العميل ده مفيش معاه تواصل قريب. افتح المحادثة تاني أو اطلب مراجعة.",
  "Proposal status": "حالة العرض",
  "Keep proposal evidence, offer text, and follow-up synchronized.": "خلّي مستندات العرض ونصه والمتابعة متوافقين.",
  "Request PDF": "طلب ملف PDF",
  "Send offer": "إرسال العرض",
  "The lead has a future commitment and recent activity.": "العميل عنده خطوة جاية بميعاد ونشاط قريب.",
  "Adjust follow-up": "تعديل المتابعة",
  "Move stage": "نقل المرحلة",
  "New WhatsApp message": "رسالة واتساب جديدة",
  "Registration completed": "التسجيل اكتمل",
  "Task overdue": "المهمة متأخرة",
  "A follow-up task is overdue and needs action now.": "مهمة متابعة متأخرة ومحتاجة إجراء دلوقتي.",
  "Follow-up due soon": "متابعة مستحقة قريب",
  "A follow-up reminder is due soon.": "تذكير متابعة قرب ميعاده.",
  "Need review response": "رد على طلب المراجعة",
  "A review request has a new response.": "طلب المراجعة عنده رد جديد.",
  "This lead has a follow-up time in the past.": "ميعاد متابعة العميل ده فات.",
  "Follow up now": "تابع دلوقتي",
  "No contact has been logged yet. Start with a call or WhatsApp.": "لسه مفيش تواصل متسجل. ابدأ بمكالمة أو واتساب.",
  "Make first contact": "ابدأ أول تواصل",
  "Hot idle": "مهتم جدًا ومن غير نشاط",
  "High-intent lead needs a current next step.": "عميل اهتمامه عالي ومحتاج خطوة جاية محددة دلوقتي.",
  "Move conversation": "تقدم بالمحادثة",
  "Open lead without a scheduled next action.": "عميل مفتوح من غير خطوة جاية بميعاد.",
  "Set next action": "تحديد الخطوة الجاية",
  "Stale": "من غير نشاط",
  "Open lead has been idle for five or more days.": "عميل مفتوح مفيش عليه نشاط من خمس أيام أو أكتر.",
  "Decide next step": "تحديد الخطوة الجاية",
  "To find a specific status, type its name in search.": "لو عايز حالة معينة اكتب اسمها في البحث.",
  "To narrow the results, select one filter at a time.": "لو عايز تضيق النتيجة اختار فلتر واحد كل مرة.",
  "Use the clear icon to remove the filter and return to the full view.": "لو لقيت علامة مسح امسح الفلتر وارجع للعرض الكامل.",
  "Save confirms the change; Cancel closes without changing anything.": "زر حفظ بيأكد التغيير؛ زر إلغاء بيقفل من غير ما يغير حاجة.",
  "Read any warning before confirming; it usually explains what is missing or what will change.": "لو ظهر تحذير اقراه قبل التأكيد؛ غالبًا بيقولك إيه الناقص أو إيه اللي هيتغير.",
  "Start in My Work with follow-ups that need action.": "ابدأ من «شغلي» بالمتابعات اللي محتاجة إجراء.",
  "Open Pipeline to find a customer or review their stage.": "افتح «مراحل البيع» للبحث عن عميل أو مراجعة مرحلته.",
  "Record the contact result and schedule the next step.": "سجّل نتيجة التواصل وحدد ميعاد الخطوة الجاية.",
  "Review My activity when you need to check your earlier work.": "راجع «نشاطي» لو محتاج ترجع لشغلك السابق.",
  "Use search or filters to find the right lead.": "استخدم البحث أو الفلاتر عشان توصل للعميل الصح.",
  "Open the lead card and read the latest activity and next action.": "افتح كارت العميل واقرأ آخر نشاط والخطوة الجاية.",
  "Call or send a message, then record what happened.": "اتصل أو ابعت رسالة وسجّل اللي حصل.",
  "Choose the actual result and schedule a follow-up if needed.": "اختار النتيجة الحقيقية وحدد المتابعة الجاية لو محتاج.",
  "Check that the new status appears on the card before closing.": "اتأكد إن الحالة الجديدة اتسجلت على الكارت قبل ما تقفل.",
  "You must work on a lead visible within your permissions.": "لازم تشتغل على عميل ظاهر في نطاق صلاحيتك.",
  "Check the name, number, and course in the Lead tab.": "راجع الاسم والرقم والكورس من تبويب «العميل».",
  "In Next step, choose the contact channel and result, then describe what happened.": "من «الخطوة الجاية» اختار قناة التواصل والنتيجة، وبعدها اكتب اللي حصل.",
  "If a follow-up is needed, select a date and time before saving.": "لو فيه متابعة، حدد تاريخ ووقت قبل الحفظ.",
  "Use History to review previous attempts and notes.": "من «السجل» راجع المحاولات والملاحظات السابقة.",
  "If the customer is ready to register, open Payment and share the registration link; the receipt becomes available after registration.": "لو العميل جاهز للتسجيل، افتح «الدفع» وشارك رابط التسجيل؛ الإيصال بيظهر بعد ما يكمّل التسجيل.",
  "Start with Act now.": "ابدأ من «محتاج إجراء دلوقتي».",
  "Open the lead and carry out the actual customer action.": "افتح العميل ونفّذ الإجراء الفعلي معاه.",
  "After carrying out the action, choose Complete and record what happened, or set a new follow-up time.": "اختار «إكمال» بعد التنفيذ واكتب اللي حصل، أو حدد ميعاد متابعة جديد.",
  "Use bulk actions only for follow-ups where you actually carried out the same action.": "استخدم الإجراءات الجماعية بس للمتابعات اللي فعلًا نفذت فيها نفس الإجراء.",
  "Choose the right conversation and check the customer's name and number.": "اختار المحادثة الصح واتأكد من اسم ورقم العميل.",
  "Read the latest messages before replying so you do not repeat a question.": "اقرأ آخر رسائل قبل الرد عشان ما تكررش سؤال.",
  "Use a template if it fits, and review it before sending.": "استخدم القالب لو مناسب وراجعه قبل الإرسال.",
  "Send the message and record any important result on the lead if needed.": "ابعت الرسالة وسجّل أي نتيجة مهمة في سجل العميل لو لزم.",
  "Use filters to select the period or activity type.": "حدد الفترة أو نوع النشاط من الفلاتر.",
  "Search by customer name to find a specific record.": "دور باسم العميل لو محتاج حالة محددة.",
  "Open the event and read the note and the change made.": "افتح الحدث واقرأ الملاحظة والتغيير اللي حصل.",
  "Use the available option to correct a note if it contains an error.": "صحّح الملاحظة من الخيار المتاح لو فيها خطأ.",
  "Choose the relevant period.": "اختار الفترة المناسبة.",
  "Review the key figures before the details.": "راجع الأرقام الأساسية قبل التفاصيل.",
  "Open the metric you want to understand.": "افتح المؤشر اللي محتاج تفهمه.",
  "Turn your observation into action: more contact, completed follow-ups, or a source review.": "حوّل الملاحظة لإجراء: زيادة تواصل، إغلاق متابعات، أو مراجعة مصدر.",
  "Select the period and filters you want to measure.": "حدد الفترة والفلاتر اللي عايز تقيس عليها.",
  "Review team metrics before assessing an individual.": "راجع مؤشرات الفريق قبل ما تحكم على فرد.",
  "Open the details for an employee, source, or course.": "افتح التفاصيل لموظف أو مصدر أو كورس.",
  "Use the result to plan follow-up, support, or redistribution.": "استخدم النتيجة لتحديد متابعة أو دعم أو إعادة توزيع.",
  "Choose the employee or course.": "اختار الموظف أو الكورس.",
  "Review the current distribution to avoid conflicts.": "راجع التوزيع الحالي عشان ما تعملش تعارض.",
  "Update the assignment and save.": "حدّث التعيين واحفظ.",
  "After saving, check its effect on new leads.": "راجع أثره على العملاء الجدد بعد الحفظ.",
  "Select the leads or transfer source.": "حدد العملاء أو مصدر النقل.",
  "Review the current owner and status before transferring.": "راجع المسؤول الحالي والحالة قبل النقل.",
  "Choose the new employee and the transfer reason.": "اختار الموظف الجديد وسبب النقل.",
  "Confirm the transfer and review the result in the customer history.": "أكد العملية وراجع النتيجة في سجل العميل.",
  "Review the queue and rejected records.": "راجع الطابور والحالات المرفوضة.",
  "Open the lead and read the decision reason and latest contact.": "افتح العميل واقرأ سبب القرار وآخر تواصل.",
  "Approve the handoff or address the rejection reason as appropriate.": "اعتمد التسليم أو عالج سبب الرفض حسب الحالة.",
  "Track the result in history and reports.": "تابع النتيجة من السجل والتقارير.",
  "Open the source mapping.": "افتح ربط الحقول الخاص بالمصدر.",
  "Review the preview before saving any change.": "راجع المعاينة قبل ما تحفظ أي تعديل.",
  "Map the fields to the correct values.": "اربط الحقول بالقيم الصحيحة.",
  "Save, then review the first new lead from that source.": "احفظ وبعدها راجع أول عميل جديد من المصدر.",
  "In Targets, set the appropriate target for the period and employee.": "في «الأهداف» حدد الهدف المناسب للفترة والموظف.",
  "In Reports, select the period and read the metrics before exporting or making a decision.": "في «التقارير» اختار الفترة، وبعدها اقرأ المؤشرات قبل التصدير أو القرار.",
  "In Settings, review the text before changing available templates or settings.": "في «الإعدادات» عدّل القوالب أو الإعدادات المتاحة بس بعد مراجعة النص.",
  "Review the impact of any change with the team.": "راجع أثر أي تغيير مع الفريق.",
  "Start with the first lead assigned to you.": "ابدأ بأول عميل مطلوب منك.",
  "Review the details, then call and clearly record the result.": "راجع البيانات وبعدها اتصل وسجّل النتيجة بوضوح.",
  "If the customer is qualified, complete the handoff using the available options.": "لو العميل مؤهل، كمّل التسليم حسب الخيارات الظاهرة.",
  "If the customer is not suitable, choose the actual rejection reason.": "لو مش مناسب، اختار سبب الرفض الحقيقي.",
  "Schedule a follow-up if you need to contact the customer again.": "حدد متابعة لو محتاج ترجع للعميل.",
  "Tasks": "المهام",
  "Communication": "التواصل",
  "WhatsApp": "واتساب",
  "History": "السجل",
};

export const employeeEnglishTranslations: Record<string, string> = {
  "استخدم أي صفحة": "Use any page",
  "معنى كل عنصر قدامك": "What each item means",
  "أي صفحة في السيلز فيها نفس القاعدة: البحث والفلاتر بيحددوا اللي شايفه، الكروت والجداول بتعرض النتيجة، والأزرار بتنفذ خطوة على العميل أو الشغل.": "Every Sales page works the same way: search and filters control what you see, cards and tables show the results, and buttons take action on a customer or task.",
  "لو واقف قدام أي كلمة أو زر ومش عارف تبدأ منين.": "When a label or button leaves you unsure where to start.",
  "تتعامل مع العناصر الظاهرة بهدوء ومن غير ما تضيّع شغلك.": "Use the visible controls confidently without losing your work.",
  "أي زر تأكيد أو حفظ بيطبق اختيارك؛ راجع الاسم والرقم والموعد قبل ما تضغطه.": "Confirm and Save buttons apply your choices. Check the name, number, and time before clicking.",
  "ابدأ من هنا": "Start here",
  "أبدأ شغلك منين؟": "Where should I start?",
  "خريطة سريعة تخليك تعرف أول حاجة تعملها في يومك.": "A quick guide to your first task of the day.",
  "في أول الشيفت أو لما تحس إن الليدات والمهام كتير.": "At the start of your shift or when leads and tasks feel overwhelming.",
  "شغلك يبقى مرتب ومفيش متابعة تضيع.": "Keep your work organized and never miss a follow-up.",
  "شغل العميل": "Customer work",
  "الـ Pipeline": "Pipeline",
  "هنا كل العملاء المحتملين ومكان كل واحد في رحلة البيع.": "All your potential customers and their progress through the sales journey.",
  "لما تدور على ليد، تبدأ متابعة، أو ترتب أولوياتك.": "When finding a lead, starting a follow-up, or setting priorities.",
  "الكارت يتحدث، والتاريخ والمهام يفضلوا واضحين للفريق.": "The card updates, keeping history and tasks clear for the team.",
  "ما تغيّرش الحالة لمجرد التجربة؛ الحالة بتأثر على تقارير الفريق.": "Do not change a stage just to try it out; it affects team reports.",
  "تفاصيل العميل والأكشنز": "Customer details and actions",
  "الدرج اللي فيه بيانات العميل، النشاط، والمتابعة والتحويل.": "The drawer with customer details, activity, follow-ups, and transfers.",
  "بعد ما تفتح أي كارت عميل.": "After opening any customer card.",
  "كل خطوة تبقى موثقة في سجل العميل.": "Every action is documented in the customer history.",
  "طلب التحويل لا ينقل الملكية تلقائيًا؛ المدير بيراجعه.": "A transfer request does not change ownership automatically; a manager reviews it.",
  "شغل الموظف": "Employee work",
  "قائمة المتابعات اللي لازم تتعمل، مرتبة بالأولوية والميعاد.": "Follow-ups you need to complete, ordered by priority and due time.",
  "عشان تخلص المستحق النهارده أو ترتب يومك.": "To finish today's due tasks or plan your day.",
  "المهمة تتقفل أو تنتقل للموعد الجديد وتتحدث أولوية الشغل.": "The task closes or moves to a new time, updating your work priorities.",
  "ما تعملش Complete لمجرد تنظيف القائمة؛ ده يبوّظ متابعة العميل.": "Do not mark a task complete just to clear the list; it disrupts customer follow-up.",
  "مكان محادثات واتساب المربوطة بحسابات السيلز.": "WhatsApp conversations linked to Sales accounts.",
  "لما العميل يتواصل كتابة أو تحتاج تكمل متابعة برسالة.": "When a customer writes to you or you need to follow up with a message.",
  "المحادثة تفضل متصلة بسياق العميل وشغل الفريق.": "The conversation stays connected to the customer context and team work.",
  "راجع اسم العميل والرسالة قبل الإرسال؛ الإرسال لا يتراجع تلقائيًا.": "Check the customer name and message before sending; sending is not automatically reversible.",
  "تاريخ نشاطك عشان تراجع المكالمات والرسائل والمتابعات.": "Your activity history for reviewing calls, messages, and follow-ups.",
  "لما تحتاج تعرف إيه اللي اتعمل أو تراجع شغلك في فترة.": "When checking what was done or reviewing your work over a period.",
  "تقدر تتابع شغلك وتفهم رحلة العميل من غير تخمين.": "Track your work and understand the customer journey without guessing.",
  "الأداء": "Performance",
  "أرقام نشاطك وتحويلاتك عشان تعرف محتاج تركز فين.": "Your activity and conversion figures show where you need to focus.",
  "في آخر اليوم أو لما تراجع أداء فترة.": "At the end of the day or when reviewing a period's performance.",
  "تقدر تاخد قرار مبني على شغلك الفعلي.": "Make decisions based on your actual work.",
  "إدارة الفريق": "Team management",
  "صورة الفريق كاملة: النتائج، التوزيع، والأولويات.": "A complete team view: results, distribution, and priorities.",
  "في متابعة يومية أو اجتماع فريق أو مراجعة فترة.": "During daily monitoring, team meetings, or period reviews.",
  "تشوف مشاكل الفريق بدري وتاخد قرار واضح.": "Spot team issues early and make clear decisions.",
  "توزيع الكورسات": "Course distribution",
  "تحديد مين مسؤول عن الكورسات ضمن الفريق.": "Assign course responsibilities within the team.",
  "لما تغيّر تغطية فريق أو تضيف موظف.": "When changing team coverage or adding an employee.",
  "التوزيع الجديد يبقى جاهز لشغل الفريق.": "The updated distribution is ready for the team to use.",
  "التغيير يؤثر على الاستلام القادم؛ راجع قبل الحفظ.": "Changes affect future assignments; review them before saving.",
  "نقل العملاء": "Customer transfers",
  "نقل أو إعادة توزيع الليدات بين أعضاء الفريق بشكل منظم.": "Transfer or redistribute leads between team members in an organized way.",
  "لما موظف يغيب، الحمل يزيد، أو العميل محتاج مسؤول تاني.": "When an employee is absent, workloads increase, or a customer needs another owner.",
  "الملكية تتغير ويتسجل أثر الحركة للمراجعة.": "Ownership changes and the transfer is recorded for review.",
  "نقل العميل يأثر على المسؤولية والتقارير؛ ما تنقلش بدون سبب واضح.": "Transferring a customer affects responsibility and reports; always have a clear reason.",
  "إدارة Tele-sales": "Tele-sales management",
  "متابعة طابور التأهيل وقرارات التسليم أو الرفض.": "Monitor the qualification queue and handoff or rejection decisions.",
  "لما تراجع جودة عمل Tele-sales أو تدير التوزيع.": "When reviewing Tele-sales quality or managing distribution.",
  "ليدات مؤهلة توصل للمسار الصح بدون فقدان السياق.": "Qualified leads reach the right workflow with their context intact.",
  "إدارة البيانات": "Data management",
  "مراجعة ربط مصادر الإعلانات والبيانات الداخلة للسيلز.": "Review how ad sources and incoming Sales data are linked.",
  "لما مصدر أو حملة جديدة مش ظاهرة بالشكل الصح.": "When a new source or campaign is not appearing correctly.",
  "البيانات تدخل بشكل أنضف في الـ Pipeline.": "Cleaner data enters the pipeline.",
  "تعديل الربط ممكن يأثر على الداتا الجديدة؛ راجع المعاينة أولًا.": "Link changes may affect new data; review the preview first.",
  "الأهداف والتقارير والإعدادات": "Targets, reports, and settings",
  "تحديد الهدف، قراءة النتائج، وضبط قوالب الشغل.": "Set targets, read results, and configure work templates.",
  "في بداية فترة جديدة أو مراجعة نتائج أو تغيير إعداد تشغيلي.": "At the start of a new period, when reviewing results, or when changing an operational setting.",
  "الأهداف والتقارير والإعدادات تفضل متوافقة مع طريقة التشغيل.": "Keep targets, reports, and settings aligned with how the team operates.",
  "القوالب والإعدادات بتأثر على الفريق كله؛ راجعها قبل الحفظ.": "Templates and settings affect the entire team; review them before saving.",
  "شغل Tele-sales": "Tele-sales work",
  "طابور Tele-sales": "Tele-sales queue",
  "ليدات محتاجة تأهيل قبل ما تتسلم للسيلز.": "Leads that need qualification before handoff to Sales.",
  "طول شيفت الـ Tele-sales.": "Throughout the Tele-sales shift.",
  "الليد يا إما يتأهل ويتسلم، يا إما يتسجل سبب واضح للحالة.": "Qualify and hand off the lead, or record a clear reason for its status.",
  "اكتب سبب الرفض بدقة عشان المدير يعرف يراجع القرار.": "Write an accurate rejection reason so the manager can review the decision.",
  "دليل مساعدة السيلز": "Sales help guide",
  "دليل شغلك خطوة بخطوة": "Your step-by-step work guide",
  "اختار موضوع أو دور على الأكشن اللي عايز تعرفه.": "Choose a topic or search for the action you want to understand.",
  "دور في المساعدة": "Search help",
  "مثال: نقل عميل أو متابعة أو واتساب": "Example: customer transfer, follow-up, or WhatsApp",
  "موضوعات المساعدة": "Help topics",
  "ملقيناش موضوع بالبحث ده. جرّب كلمة أبسط أو امسح البحث.": "No matching topic. Try a simpler word or clear your search.",
  "استخدمها إمتى؟": "When should I use it?",
  "قبل ما تبدأ": "Before you start",
  "اعمل إيه؟": "What should I do?",
  "النتيجة:": "Result:",
  "خلي بالك:": "Keep in mind:",
  "نسخ الرسالة": "Copy message",
  "مساعدة السيلز": "Sales help",
  "افتح دليل مساعدة السيلز": "Open the Sales help guide",
  "مساعدة": "Help",
  "لو عايز حالة معينة اكتب اسمها في البحث.": "To find a specific status, type its name in search.",
  "لو عايز تضيق النتيجة اختار فلتر واحد في كل مرة.": "To narrow the results, select one filter at a time.",
  "لو لقيت علامة مسح امسح الفلتر وارجع للعرض الكامل.": "Use the clear icon to remove the filter and return to the full view.",
  "الزر اللي عليه حفظ بيأكد التغيير؛ زر إلغاء بيقفل من غير ما يغير حاجة.": "Save confirms the change; Cancel closes without changing anything.",
  "لو ظهر تحذير اقراه قبل التأكيد؛ غالبًا بيقولك إيه الناقص أو إيه اللي هيتغير.": "Read any warning before confirming; it usually explains what is missing or what will change.",
  "ابدأ من My Work بالمتابعات اللي محتاجة أكشن.": "Start in My Work with follow-ups that need action.",
  "افتح الـ Pipeline للبحث عن عميل أو مراجعة مرحلته.": "Open Pipeline to find a customer or review their stage.",
  "سجّل نتيجة التواصل وحدد موعد الخطوة الجاية.": "Record the contact result and schedule the next step.",
  "راجع My activity لو محتاج ترجع لشغلك السابق.": "Review My activity when you need to check your earlier work.",
  "استخدم البحث أو الفلاتر عشان توصل لليد الصح.": "Use search or filters to find the right lead.",
  "افتح كارت الليد واقرأ آخر نشاط والـ Next action.": "Open the lead card and read the latest activity and next action.",
  "اتصل أو ابعت رسالة وسجّل اللي حصل.": "Call or send a message, then record what happened.",
  "اختار النتيجة الحقيقية وحدد المتابعة الجاية لو محتاج.": "Choose the actual result and schedule a follow-up if needed.",
  "اتأكد إن الحالة الجديدة اتسجلت على الكارت قبل ما تقفل.": "Check that the new status appears on the card before closing.",
  "لازم تشتغل على ليد ظاهر في نطاق صلاحيتك.": "You must work on a lead visible within your permissions.",
  "راجع الاسم والرقم والكورس من تبويب Lead.": "Check the name, number, and course in the Lead tab.",
  "من Next step اختار قناة التواصل والنتيجة ثم اكتب اللي حصل.": "In Next step, choose the contact channel and result, then describe what happened.",
  "لو فيه متابعة، حدد تاريخ ووقت قبل الحفظ.": "If a follow-up is needed, select a date and time before saving.",
  "من History راجع المحاولات والملحوظات السابقة.": "Use History to review previous attempts and notes.",
  "لو العميل جاهز للتسجيل، افتح Payment وشارك رابط التسجيل؛ الإيصال يظهر بعد إكماله.": "If the customer is ready to register, open Payment and share the registration link; the receipt becomes available after registration.",
  "ابدأ من Act now.": "Start with Act now.",
  "افتح الليد وخد الأكشن الحقيقي مع العميل.": "Open the lead and carry out the actual customer action.",
  "اختار Complete بعد التنفيذ واكتب اللي حصل، أو حدد موعد متابعة جديد.": "After carrying out the action, choose Complete and record what happened, or set a new follow-up time.",
  "استخدم الـ Bulk actions بس للمتابعات اللي فعلًا عملت فيها نفس الأكشن.": "Use bulk actions only for follow-ups where you actually carried out the same action.",
  "اختار المحادثة الصح واتأكد من اسم/رقم العميل.": "Choose the right conversation and check the customer's name and number.",
  "اقرأ آخر رسائل قبل الرد عشان ما تكررش سؤال.": "Read the latest messages before replying so you do not repeat a question.",
  "استخدم القالب لو مناسب وراجعه قبل الإرسال.": "Use a template if it fits, and review it before sending.",
  "ابعت الرسالة وسجّل أي نتيجة مهمة في العميل لو لزم.": "Send the message and record any important result on the lead if needed.",
  "حدد الفترة أو نوع النشاط من الفلاتر.": "Use filters to select the period or activity type.",
  "ابحث باسم العميل لو محتاج حالة محددة.": "Search by customer name to find a specific record.",
  "افتح الحدث واقرأ الملحوظة والتغيير اللي حصل.": "Open the event and read the note and the change made.",
  "صحّح الملاحظة من الخيار المتاح لو فيها خطأ.": "Use the available option to correct a note if it contains an error.",
  "اختار الفترة المناسبة.": "Choose the relevant period.",
  "راجع الأرقام الأساسية قبل التفاصيل.": "Review the key figures before the details.",
  "افتح المؤشر اللي محتاج تفهمه.": "Open the metric you want to understand.",
  "حوّل الملاحظة لأكشن: زيادة تواصل، إغلاق متابعات، أو مراجعة مصدر.": "Turn your observation into action: more contact, completed follow-ups, or a source review.",
  "حدد الفترة والفلاتر اللي عايز تقيس عليها.": "Select the period and filters you want to measure.",
  "راجع مؤشرات الفريق قبل ما تحكم على فرد.": "Review team metrics before assessing an individual.",
  "افتح التفاصيل لموظف أو مصدر أو كورس.": "Open the details for an employee, source, or course.",
  "استخدم النتيجة لتحديد متابعة أو دعم أو إعادة توزيع.": "Use the result to plan follow-up, support, or redistribution.",
  "اختار الموظف أو الكورس.": "Choose the employee or course.",
  "راجع التوزيع الحالي عشان ما تعملش تعارض.": "Review the current distribution to avoid conflicts.",
  "حدّث التخصيص واحفظ.": "Update the assignment and save.",
  "راجع أثره على الليدات الجديدة بعد الحفظ.": "After saving, check its effect on new leads.",
  "حدد الليدات أو مصدر الحركة.": "Select the leads or transfer source.",
  "راجع المالك الحالي والحالة قبل النقل.": "Review the current owner and status before transferring.",
  "اختار الموظف الجديد وسبب النقل.": "Choose the new employee and the transfer reason.",
  "أكد العملية وراجع النتيجة في سجل العميل.": "Confirm the transfer and review the result in the customer history.",
  "راجع الطابور والحالات المرفوضة.": "Review the queue and rejected records.",
  "افتح الليد واقرأ سبب القرار وآخر تواصل.": "Open the lead and read the decision reason and latest contact.",
  "اعتمد التسليم أو عالج سبب الرفض حسب الحالة.": "Approve the handoff or address the rejection reason as appropriate.",
  "تابع النتيجة من السجل والتقارير.": "Track the result in history and reports.",
  "افتح الـ Mapping الخاص بالمصدر.": "Open the source mapping.",
  "راجع المعاينة قبل ما تحفظ أي تعديل.": "Review the preview before saving any change.",
  "اربط الحقول بالقيم الصحيحة.": "Map the fields to the correct values.",
  "احفظ ثم راجع أول ليد جديد من المصدر.": "Save, then review the first new lead from that source.",
  "في Targets حدد الهدف المناسب للفترة والموظف.": "In Targets, set the appropriate target for the period and employee.",
  "في Reports اختار الفترة ثم اقرأ المؤشرات قبل التصدير أو القرار.": "In Reports, select the period and read the metrics before exporting or making a decision.",
  "في Settings عدّل القوالب أو الإعدادات المتاحة فقط بعد مراجعة النص.": "In Settings, review the text before changing available templates or settings.",
  "راجع أثر أي تغيير مع الفريق.": "Review the impact of any change with the team.",
  "ابدأ بأول ليد مطلوب منك.": "Start with the first lead assigned to you.",
  "راجع البيانات ثم اتصل وسجّل النتيجة بوضوح.": "Review the details, then call and clearly record the result.",
  "لو العميل مؤهل، كمّل التسليم حسب الخيارات الظاهرة.": "If the customer is qualified, complete the handoff using the available options.",
  "لو غير مناسب، اختار سبب الرفض الحقيقي.": "If the customer is not suitable, choose the actual rejection reason.",
  "حدد متابعة لو محتاج ترجع للعميل.": "Schedule a follow-up if you need to contact the customer again.",
  "المهام": "Tasks",
  "التواصل": "Communication",
  "واتساب": "WhatsApp",
  "السجل": "History",
};
